<template>
  <!-- 快捷活动弹窗 -->
  <!-- <div class="quickActivity absolute top-0 right-0 h-full z-9999" :class="{ 'w-full': quickActivityFlag }">
    <div class="relative w-full h-full">
      <div class="absolute top-0 left-0 w-full h-full bg-[rgba(0,0,0,0.75)]"></div>
      <div class="absolute top-1/2 right-0 transform -translate-y-1/2 h-[58.6%] z-[999]">
        <div class="max-w-[155px] h-full relative flex items-center">
          <div :class="{ 'ml-[4px]': quickActivityFlag }"
            class="absolute left-0 top-1/2 z-3 transform -translate-y-1/2 w-[25px] -translate-x-full">
            <div @click="quickActivityFlag = !quickActivityFlag" class="relative cursor-pointer">
              <img :src="getAssetsFile('home/activitysPopIconBtn.png')" class="w-[25px] h-auto relative z-1" />
              <img v-if="!quickActivityFlag"
                class="absolute w-[12px] h-[29px] top-1/2 left-1/2 transform -translate-y-3/4 -translate-x-1/2 z-3"
                :src="getAssetsFile('home/activitysPopOpenIcon.png')" />
              <img v-if="quickActivityFlag"
                class="absolute w-[12px] h-[29px] top-1/2 left-1/2 transform -translate-y-3/4 -translate-x-1/2 z-3"
                :src="getAssetsFile('home/activitysPopCloseIcon.png')" />
            </div>
          </div>
          <div v-show="quickActivityFlag" class="w-[131px] h-full relative z-2">
            <div class="w-full h-full quickActivityContent p-[10px] flex flex-wrap justify-between">
              <div v-for="(item, index) in quickActivitys" :key="index" @click="goActivitys(item)"
                class="w-1/2 p-[5px] flex items-center itemBox cursor-pointer">
                <img :src="VITE_IMG_URL + (item.img.en || item.img.pt)" class="w-full h-auto relative">
                <div class="red-dot" v-if="shouldShowLensEffect(item)"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div> -->

  <!-- 添加 wakdog 弹窗 -->
  <wakdog v-if="showWakdogModal" @close="closeWakdogModal" @confirm="closeWakdogModal" />

  <!-- 在模板末尾添加弹窗组件 -->
  <GlobalPopup v-model:visible="showPopup" :auto-fetch="true" />

  <!-- 在模板末尾添加 firstExit 弹窗 -->
  <firstExit v-model:show="showFirstExitModal" :amount="firstExitAmount" @confirm="confirmFirstExit" @update:show="
    showFirstExitModal = $event;
  if (!$event) closeFirstExitModal();
  " />
  <firstMentioned v-model:show="showFirstMentionedModal" :amount="firstMentionedAmount"
    @confirm="closeFirstMentionedModal" />
  <!-- 奖励弹窗 -->
  <RewardPopup :show="showRewardPopup" @close="closeRewardPopup" @abandon="handleAbandonReward" />
  <!-- 新闻弹窗 -->
  <newswindows v-model:visible="showNewsWindows" :accordion-data="newsAccordionData" :auto-fetch="true"
    @close="handleNewsClose" />
  <!-- 抽屉 -->
  <van-popup v-model:show="popFlag" position="left">
    <div class="pop-container w-screen h-screen">
      <div class="w-full h-[55px] popHeader px-[12px] flex">
        <div class="w-full h-full relative">
          <div @click="popFlag = false" :class="{ 'transform rotate-180': !popFlag, 'transform rotate-0': popFlag }"
            class="h-full flex items-center absolute left-0 top-0 z-2">
            <img :src="getAssetsFile('home/popCloseIcon.png')" alt="" class="h-[25px] w-[22px]" />
          </div>
          <div
            class="w-full flex items-center justify-center absolute left-0 top-0 h-full text-[18px] text-white font-bold">
            {{ t("AppName") }}
          </div>
        </div>
      </div>
      <!-- 内容区域 -->
      <div class="popContent h-[calc(100%-55px)] p-[16px] overflow-y-auto">
        <!-- 游戏类型 -->
        <div class="gameTypes flex flex-wrap justify-between">
          <div v-for="(item, index) in sidebarMenuMaster" @click="toggleMenu(item)" :key="index"
            class="gameTypesItem h-[43px] w-[48.2%] px-[13px] py-[6px] flex items-center mb-[15px]">
            <div class="gameTypesItemIcon w-[27px] h-[27px] flex items-center justify-center">
              <img :src="item.icon" alt="" class="w-[20px] h-[20px] object-cover" />
            </div>
            <div class="gameTypesItemText ml-[5px] text-[12px] font-bold text-white">
              {{ t('home.' + item.title.toLowerCase()) }}
            </div>
          </div>
        </div>
        <!-- 投注记录 -->
        <div @click="goBetRecord()" class="betRecordContainer px-[11px] py-[17px] h-[78px] flex items-center">
          <div class="betRecordLeft w-[44px] h-[44px] flex items-center justify-center mr-[11px]">
            <img :src="getAssetsFile('home/popBetRecordLeftIcon.png')" alt="" class="w-[30px] h-[30px] object-cover" />
          </div>
          <div class="h-full flex flex-col justify-around">
            <div class="text-[12px] text-white font-bold">{{ t('home.bettingRecords') }}</div>
            <div class="text-[12px] text-[#F2F63B] font-bold">
              {{ VITE_SYMBOL }} {{ numberFormat(userStore.userInfo.todayBet || 0) }}
            </div>
          </div>
        </div>
        <!-- 客服 -->
        <div @click="goCustomerService()" class="customerServiceContainer mt-[16px] h-[42px] w-full p-[2px]">
          <div class="box h-full w-full px-[8px] flex items-center">
            <div class="h-full flex items-center mr-[10px] relative">
              <img :src="getAssetsFile('home/popCustomerServiceContainerIcon.png')" alt=""
                class="w-[34px] h-[26px] object-cover" />
              <RedDot @click="goToMensagens()" class="absolute top-[5px] right-[5px]" v-if="messageStore.count > 0"
                :count="messageStore.count" :big="messageStore.count > 10" />
            </div>
            <div class="text-[12px] text-white font-bold">{{ t('home.support') }}</div>
          </div>
        </div>
        <!-- banner -->
        <div class="bannerContainer">
          <div v-for="(item, index) in sidebarBannerData" :key="index" @click="handleSidebarBannerClick(item)"
            class="box w-full h-[100px] mt-[16px] w-full p-[2px]">
            <div class="w-full h-full rounded-[4px] overflow-hidden">
              <img :src="VITE_IMG_URL + item.picture" class="w-full h-full object-cover" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </van-popup>
  <div v-show="showTopIcon" class="fixed-top-btn" @click="scrollToTop">
    <img :src="getAssetsFile('home/top1.png')" alt="" class="w-full h-full">
  </div>
  <!-- 顶部下载apk的提示内容 -->
  <div class="w-full flex items-center py-[5px] bg-[#083A36] border-b-1 border-solid border-[#083A36] -mb-[2px]"
    v-if="showDownloadBanner">
    <div class="w-1/8 px-[5px]">
      <Button @click="closeDownloadBanner" type="close" />
    </div>
    <div class="w-7/8 flex">
      <div class="w-3/5 flex items-center">
        <img :src="getAssetsFile('logo2.png')" alt="Logo" class="h-[40px] mr-[6px]" />
        <img :src="getAssetsFile('activity/apss.png')" alt="" class="w-[calc(100%-40px)] h-auto" />
      </div>
      <div class="w-2/5 flex items-center justify-end px-[10px]">
        <img :src="getAssetsFile('home/installBtn.png')" alt="Install" class="w-full h-auto" @click="handleInstall" />
      </div>
    </div>
  </div>
  <div ref="homePageRef" class="home-container overflow-y-auto"
    :class="{ 'h-[calc(100vh-60px)]': showDownloadBanner || true }">
    <!-- 头部区域 -->
    <div class="header-area flex sticky top-0 z-10">
      <div class="w-1/5 h-full">
        <div class="w-full h-full flex items-center">
          <div class="w-1/2 h-full pl-[12px]">
            <div class="h-full flex items-end justify-center pb-[12px]">
              <img :src="getAssetsFile('home/popStartIcon.png')" @click="
                popFlag = true;
              trackHomeClickMenuButton();
              " :class="{ 'transform rotate-180': popFlag }" class="w-[25px] h-[22px]" alt="" />
              <!-- <img v-else :src="getAssetsFile('home/popEndIcon.png')" @click="popFlag = false"
                :class="{ 'transform -rotate-180': !popFlag }" class="w-[25px] h-[22px]" alt="" /> -->
            </div>
          </div>
          <div class="w-1/2 pb-[12px] h-full flex items-end justify-center ">
            <div class="h-1/2 ">
              <img :src="vipStore.vipInfo?.currentVip?.icon ? VITE_IMG_URL + vipStore.vipInfo?.currentVip?.icon : vipIconMap.get(vipStore.vipInfo?.level || 0)
                " @click="toVip()" alt="" class="max-w-[26px] max-h-[26px] w-auto h-auto" />
            </div>
          </div>
        </div>
      </div>
      <div class="w-3/5 h-full flex items-center justify-end">
        <!-- 已登录 -->
        <div v-if="isLogin" class="flex items-center">
          <!-- 钱包余额 -->
          <div v-if="IS_DOUBLE_WALLET" class="mr-[30px]">
            <div class="text-[#FAEC3C] text-[12px] font-bold mr-[10px]">
              <span>{{ VITE_SYMBOL }}</span> {{ numberFormat(cash) }}
            </div>
            <!-- 钱包按钮 -->
            <div @click="openWallet()" class="relative w-[54px] h-[30px] wallet flex items-center justify-center">
              <img :src="getAssetsFile('home/walletIcon.png')" alt="" class="w-[18px] h-[18px] bounce-small" />
            </div>
          </div>

          <div v-else class="flex double-wallet mr-[26px]">
            <div @click="showDoubleWallet = true"
              class=" text-[#FAEC3C] text-[12px] font-bold pl-[10px] py-[4px] rounded-[10px] pr-[31px] relative flex items-center">
              <span v-if="walletFlag == 'cash'">{{ VITE_SYMBOL }} {{ numberFormat(cash) }}</span>
              <span v-if="walletFlag == 'bonus'">{{ numberFormat(bonus) }}</span>
              <span
                class="arrow absolute right-[3px] -mt-[1px] top-1/2 transform -translate-y-1/2 -translate-x-1/2"></span>
            </div>
            <div @click="openWallet()" class="relative w-[54px] h-[30px] wallet flex items-center justify-center">
              <img :src="getAssetsFile('home/walletIcon.png')" alt="" class="w-[18px] h-[18px] bounce-small " />
            </div>
            <van-popover v-model:show="showDoubleWallet" theme="dark" placement="bottom-end" :offset="[-65, 0]"
              :show-arrow="false" actions-direction="vertical">
              <template #default>
                <div class="selectLangContainer w-[106px] pt-[10px] pb-[10px] px-[6px]">
                  <div>
                    <div class="w-full h-[27px]  text-[#4CAE83] flex items-center justify-center">
                      <div class="h-full w-full flex hover:text-white" :class="{ 'text-white': walletFlag == 'cash' }"
                        @click="walletFlag = 'cash'; showDoubleWallet = false;">
                        <div class="w-9/24">
                          <div class="w-full h-full flex items-center justify-end  text-[10px]">
                            {{ t("cash") }}:
                          </div>
                        </div>
                        <div class="w-15/24">
                          <div
                            class="text-[10px] h-full w-full flex justify-start items-center  cursor-pointer text-overflow-ellipsis overflow-hidden whitespace-nowrap">
                            {{ VITE_SYMBOL }} {{ numberFormat(cash) }}
                          </div>
                        </div>

                      </div>
                    </div>
                    <div class="w-full h-[27px]  text-[#4CAE83] flex items-center justify-center">
                      <div class="h-full w-full flex hover:text-white" :class="{ 'text-white': walletFlag == 'bonus' }"
                        @click="walletFlag = 'bonus'; showDoubleWallet = false;">
                        <div class="w-9/24">
                          <div class="w-full h-full flex items-center justify-end  text-[10px]">
                            {{ t("bonus") }}:
                          </div>
                        </div>
                        <div class="w-15/24">
                          <div
                            class="text-[10px] h-full w-full flex justify-start items-center  cursor-pointer text-overflow-ellipsis overflow-hidden whitespace-nowrap">
                            {{ numberFormat(bonus) }}
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>

              </template>
            </van-popover>

          </div>

        </div>

        <!-- 未登录 -->
        <div v-else class="flex items-center w-full flex justify-center">
          <div v-trans="{
            type: 'heartbeat',
            scale: 1.1,
          }" @transitionend="openLogin"
            class="login mr-[4px] w-[75px] h-[30px] flex items-center justify-center text-[11px] font-bold text-[#fff]">
            {{ t("home.enter") }}
          </div>
          <div v-trans="{
            type: 'heartbeat',
            scale: 1.1,
          }" @transitionend="openRegister"
            class="register w-[75px] h-[30px] flex items-center justify-center text-[11px] font-bold text-[#fff]">
            {{ t("home.register") }}
          </div>
        </div>
      </div>
      <div class="w-1/5 h-full flex items-center">
        <div class="w-1/2 h-full flex items-end justify-center pb-[6px]">
          <div class="relative">
            <img @click="goToMensagenss()" :src="getAssetsFile('home/messageIcon.png')" alt=""
              class="w-[32px] h-[27px]" />
            <RedDot class="absolute top-0 right-0" v-if="messageStore.count > 0" :count="messageStore.count"
              :big="messageStore.count > 10" />

          </div>
        </div>
        <div class="w-1/2 h-full flex items-end justify-center pb-[8px]">
          <div>
            <img @click="showLangSelect = true" :src="getAssetsFile('home/langIcon.png')" alt=""
              class="w-[23px] h-[23px]" />
            <van-popover v-model:show="showLangSelect" theme="dark" placement="bottom-end" :offset="[4, -2]"
              :show-arrow="false" :actions="langs" actions-direction="vertical">
              <template #default>
                <div class="selectLangContainer w-[106px] pt-[10px] pb-[10px] px-[6px]">
                  <div>
                    <div class="w-full h-[27px]  text-[#4CAE83] flex items-center justify-center"
                      @click="handleLangSelect(i)" v-for="i in langs" :key="i">
                      <div class="h-full w-full flex">
                        <div class="w-8/24">
                          <div class="w-full h-full flex items-center justify-center">
                            <div class="w-[18px]">
                              <img v-if="i.icon" :src="i.icon" class="w-full h-auto">
                            </div>
                          </div>
                        </div>
                        <div class="w-12/24">
                          <div
                            class="text-[12px] h-full w-full flex justify-start items-center hover:text-[#FFFFFF] cursor-pointer"
                            :class="{ 'text-[#FFFFFF]': locale == i.value }">
                            {{ i.text }}
                          </div>
                        </div>
                        <div class="w-4/24">
                          <div v-if="locale == i.value"
                            class="h-full w-full flex justify-center items-center text-[#8BD44B]">
                            <van-icon :size="15" name="success" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </template>
            </van-popover>

          </div>

          <div></div>
        </div>
      </div>
    </div>
    <!-- 内容区域 -->
    <div class="content-area !pb-0 !pt-[15px]">
      <!-- 轮播图容器 -->
      <div class="carousel-container relative box-border  p-[5px]">
        <div class="relative w-full h-full rounded-[10px] overflow-hidden">
          <div class="absolute top-0 left-0 w-full h-full z-2 pointer-events-none">
            <img :src="getAssetsFile('home/carouselContainerModel.png')" alt=""
              class="w-full h-full rounded-[8.5px] overflow-hidden" />
          </div>
          <div class="w-full h-full relative z-1">
            <!-- 添加加载状态 -->
            <div v-if="loadingStates.carousel" class="swipe-loading">
              <van-loading type="spinner" color="#17B663" />
            </div>
            <van-swipe v-else class="h-full w-full" :autoplay="3000" :show-indicators="false">
              <van-swipe-item v-for="(item, index) in filteredCarouselList" :key="index">
                <img :src="VITE_IMG_URL + item.picture" alt=""
                  class="h-full w-[calc(100%+5px)] sm:w-full object-cover rounded-[10px] overflow-hidden"
                  @click.stop="goBanner(item)" />
              </van-swipe-item>
            </van-swipe>
          </div>
        </div>
      </div>
      <!-- 跑马灯 -->
      <div class="ticker-container mt-[9px]">
        <div class="flex w-full h-full">
          <div class="w-1/6 flex items-center pl-[15px]">
            <img :src="getAssetsFile('home/tickerIcon.png')" alt=""
              class="w-[17px] h-[17px] transform -translate-y-[1px]" />
          </div>
          <div class="w-5/6 flex items-center justify-center relative pr-[10px]">
            <Ticker />
            <RedDot @click="goToMensagens()" class="absolute top-[5px] right-[5px]" v-if="messageStore.count > 0"
              :count="messageStore.count" :big="messageStore.count > 10" />
          </div>
        </div>
      </div>
      <!-- 广告位 -->
      <div class="banner-container mt-[10px] flex">
        <div class="h-[74px] w-full flex items-center justify-between">
          <div class="w-3.25/10 h-full banner-item flex items-center justify-center p-[5px]"
            @click="goActivity(item, index)" v-for="(item, index) in bannderData">
            <div class="w-full h-full rounded-[4px] overflow-hidden">
              <img :src="VITE_IMG_URL + item.img" alt="" class="h-full w-full object-cover" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 内容区域 -->
    <div class="content-area !px-[15px] !py-0  z-10">
      <!-- 厂商列表 -->
      <div class="vendor-container overflow-hidden mt-[10px] flex">
        <div ref="vendorScrollRef"
          class="w-7/8 tab-container whitespace-nowrap overflow-x-auto scrollbar-none flex flex-nowrap">
          <div class="w-1/6 h-full flex items-center justify-center">
            <div ref="tabRefs" :class="{ 'like': activeVendor == 0 }"
              class=" h-[28.15px] w-[56.2px] flex items-center justify-center" @click="getHomeVendorConfig()">
              <img :src="getAssetsFile('home/like.png')" alt=""
                class="w-[22px] h-[22px] transform translate-y-[0px] -translate-x-[0px]" />
            </div>
          </div>
          <div class="w-1/6 h-full flex items-center justify-center" ref="tabRefs" v-for="(item, index) in vendors"
            :class="{ 'mr-[2px]': index == vendors.length - 1 }" :key="item.id">
            <div :class="{ 'active': activeVendor == (index + 1) }"
              class=" h-[28.15px] w-[56.2px] flex items-center justify-center" @click="handleVendorClick(item, index)">
              <img :src="VITE_IMG_URL + item.logo" alt=""
                class=" h-[25px] transform translate-y-[0px] translate-x-[0px] " />
            </div>
          </div>
        </div>
        <div class="w-1/8 relative">
          <div class="h-full absolute left-[2px] top-0 transform -translate-x-1/2">
            <img :src="getAssetsFile('home/vendorPageDividing.png')" alt="" class="h-full w-auto" />
          </div>
          <div class="w-full h-full flex items-center justify-center">
            <img @click="vendorNextPage()" v-trans="'heartbeat'" :src="getAssetsFile('home/vendorNextPageIcon.png')"
              alt="" class="w-[14px] h-[24px] transform -translate-y-[1px]" />
          </div>
        </div>
      </div>
    </div>

    <!-- 内容区域 -->
    <div class="content-area !pt-0">
      <!-- 搜索 -->
      <div class="search-container mt-[15px] flex" @click="handleSearch()">
        <div class="search shadow-lg w-full <sm:h-[24px] h-[28px] flex">
          <div class="w-4/5 flex">
            <div class="w-1/8 flex items-center justify-center">
              <img :src="getAssetsFile('home/searchIcon.png')" alt=""
                class="<sm:w-[12px] <sm:h-[14.5px] w-[16px] h-[18px] transform translate-y-[1px]" />
            </div>
            <div class="w-7/8 flex items-center text-[#ADB1B0] text-[12px]">
              {{ t('pesquisar.searchPlaceholder') }}
            </div>
          </div>
          <div class="w-1/5 flex items-center justify-center text-[12px] text-[#fff] font-bold">
            {{ t('pesquisar.title') }}
          </div>
        </div>
      </div>
      <!-- 收藏游戏列表 -->
      <div v-if="activeVendor == 0 && favoriteGames.length > 0" class="favorite-games-container mt-[15px]">
        <div class="title h-[16px] flex items-center justify-between px-[19px]">
          <div class="h-full flex items-center">
            <img :src="getAssetsFile('home/favoriteGamesTitleIcon.png')" alt=""
              class="w-[8.2px] h-[7px] <sm:w-[10px] <sm:h-[9px]" />
          </div>
          <div class="h-full">
            <img :src="getAssetsFile('home/favoriteGamesTitle.png')" alt="" class="w-auto h-[80%]" />
          </div>
          <div class="h-full flex items-center">
            <img :src="getAssetsFile('home/favoriteGamesTitleIcon.png')" alt=""
              class="w-[8.2px] h-[7px] <sm:w-[10px] <sm:h-[9px]" />
          </div>
        </div>
        <div class="content">
          <div v-if="loadingStates.favorite" class="flex items-center justify-center mt-[20px]">
            <van-loading type="spinner" color="#17B663" />
          </div>
          <div v-else>
            <div>
              <Game v-for="(game, index) in favoriteGames" :show-favorite="true" :key="index" :show-hot="true"
                class="w-1/3 mt-[14px]" @update:game="loadPageData" :game="game" />
            </div>
            <div class="mt-[34px]">
              <div class="text-[#76B5A5] text-center text-[12px] ">
                {{ t('home.showing') }} {{ favoriteGames.length }} {{ t('home.of') }} {{ pages.favorite.total }} {{
                  t('home.games') }}
              </div>

              <div v-if="
                !loadingStates.favorite && favoriteGames.length < pages.favorite.total
              " @click="
                () => {
                  loadAllGames({
                    id: 'favorite',
                  })

                }
              " class=" text-[#17B663] text-[12px] text-center mt-[7px] font-bold cursor-pointer">
                {{ t('home.showAll') }} <img :src="getAssetsFile('home/expandIcon.png')" alt=""
                  class="w-[8px] h-[8px] ml-[4px] transform duration-300">

              </div>
              <div v-if="pages.favorite.pageSize >= pages.favorite.total" @click="() => {
                pages.favorite && (pages.favorite.pageSize = 12); getFavoriteGames()
              }" class="text-[#17B663] text-[12px] text-center mt-[7px] font-bold cursor-pointer">
                {{ t('home.collapse') }} <img :src="getAssetsFile('home/expandIcon.png')" alt=""
                  class="w-[8px] h-[8px] ml-[4px] transform duration-300 rotate-180">

              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 游戏列表 -->
      <div class="game-list-container mt-[15px]">
        <template v-for="(item, index) in homeVendorGameConfig" :key="index">
          <div v-if="item.games.length > 0" class="mt-[19px]">
            <div class="svgstag flex items-center relative">
              <img v-if="item.icon" :src="VITE_IMG_URL + item.icon" alt="" class="w-auto h-auto ml-[10px]"
                style="width: 8%; height: 60%; object-fit: contain" />
              <img v-else-if="item.img" style="width: 8%; height: 60%; object-fit: contain"
                class="w-auto h-auto ml-[10px]" :src="item.img" alt="" srcset="" />
              <span v-else class="text-[12px] color-[#ffffff] absolute left-[3%] font-bold">
                <img :src="getAssetsFile('home/vendorALL.png')" alt=""
                  class="w-[22px] h-[12px] transform translate-y-[2px]" />
              </span>
              <div class="text-[12px] color-[#ffffff] absolute left-[15%] font-bold">
                {{ item.type ? t("home." + item.type.toLowerCase()) : item.type }}
              </div>
              <div class="flex items-center absolute right-[3%] top-[15px]">
                <img v-trans="{
                  type: 'heartbeat',
                  scale: 1.1,
                }" :src="getAssetsFile('home/zuoyou (2).png')" alt="" class="w-[20px] h-[20px]" :class="{
                  'opacity-50 cursor-not-allowed': pages[item.id]?.pageNo <= 1,
                  'cursor-pointer': pages[item.id]?.pageNo > 1,
                }" @click="pages[item.id]?.pageNo > 1 && gameListPrevPage(item)" style="cursor: pointer" />
                <img v-trans="{
                  type: 'heartbeat',
                  scale: 1.1,
                }" :src="getAssetsFile('home/zuoyou (1).png')" alt="" class="w-[20px] h-[20px] ml-[6px]" :class="{
                  'opacity-50 cursor-not-allowed': !pages[item.id]?.hasMore,
                  'cursor-pointer': pages[item.id]?.hasMore,
                }" @click="pages[item.id]?.hasMore && gameListNextPage(item)" style="cursor: pointer" />
              </div>
            </div>
            <div>
              <div>
                <Game v-for="(game, index) in item.games" :key="index" class="w-1/3 mt-[14px]" :game="game"
                  @update:game="updateGame(game)" :show-favorite="true" :show-hot="true" />
              </div>
            </div>
            <div class="mt-[30px]">
              <div class="text-[#76B5A5] text-center text-[12px]">
                {{ t('home.showing') }} {{ item.games.length }} {{ t('home.of') }} {{ pages[item.id]?.total }} {{
                  t('home.games') }}
              </div>
              <div v-if="
                !loadingStates.games &&
                pages[item.id]?.total > item.games.length &&
                pages[item.id]?.hasMore
              " @click="loadAllGames(item)"
                class="text-[#17B663] text-[12px] text-center mt-[7px] font-bold cursor-pointer">
                {{ pages[item.id]?.pageSize < pages[item.id]?.total ? t('home.showAll') : t('home.collapse') }} <img
                  :src="getAssetsFile('home/expandIcon.png')" alt=""
                  class="w-[8px] h-[8px] ml-[4px] transform duration-300"
                  :class="{ 'rotate-180': !(pages[item.id]?.pageSize < pages[item.id]?.total) }">

              </div>
              <div v-if="

                pages[item.id]?.pageSize >= pages[item.id]?.total

              " @click="() => {
                pages[item.id] && (pages[item.id].pageSize = 12); updatePageGame(item)
              }" class="text-[#17B663] text-[12px] text-center mt-[7px] font-bold cursor-pointer">
                {{ pages[item.id]?.pageSize < pages[item.id]?.total ? t('home.showAll') : t('home.collapse') }} <img
                  :src="getAssetsFile('home/expandIcon.png')" alt=""
                  class="w-[8px] h-[8px] ml-[4px] transform duration-300"
                  :class="{ 'rotate-180': !(pages[item.id]?.pageSize < pages[item.id]?.total) }">

              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <!-- 底部区域 -->
    <div class="bottom-area">
      <div class="w-[40px] h-[40px] fixed-top-btnKefus relative floating-element" @click="goCustomerService">
        <img :src="getAssetsFile('home/popCustomerServiceContainerIcon@2x.png')" alt=""
          class="w-full h-auto support-icons" />
        <!-- 客服图标红点 -->
        <RedDot @click="goToMensagens()" class="absolute top-[5px] right-[5px]" v-if="messageStore.count > 0"
          :count="messageStore.count" :big="messageStore.count > 10" />
      </div>

      <div class="footerstyle">
        <p style="line-height: 30px">{{ t("home.footer.companyInfo") }}</p>
        <p style="line-height: 30px">{{ t("home.footer.ageWarning") }}</p>
        <p style="line-height: 30px">{{ t("home.footer.inAppPurchase") }}</p>
        <p style="line-height: 30px">{{ t("home.footer.gamblingWarning") }}</p>
        <p style="line-height: 30px">{{ t("home.footer.copyright") }}</p>
        <div class="flex justify-center items-center">
          <p>{{ t("home.footer.copyrightTop") }}</p>
        </div>
      </div>
      <!-- 只有status为0时才显示浮标 -->
      <div class="fuchaungs">
        <div class="fuchangscenter flex flex-col" v-if="rewardStore.status == 0" @click="openRewardPopup">
          <div class="text-[9px] color-[#FFFFFF]">{{ t("home.newUserReward") }}</div>
          <div class="text-[13px] color-[#FFF268] my-[2px] font-bold" v-if="rewardStore.rewardAmount.reward > 0">
            {{ VITE_SYMBOL }}
            {{ numberFormat(rewardStore.rewardAmount.reward, { minDecimals: 2 }) }} ({{ t("cash") }})
          </div>
          <div class="text-[13px] color-[#FFF268] my-[2px] font-bold" v-if="rewardStore.rewardAmount.rewardBound > 0">
            {{ VITE_SYMBOL }}
            {{ numberFormat(rewardStore.rewardAmount.rewardBound, { minDecimals: 2 }) }}
          </div>
          <div class="color-[#FFFFFF] text-[9px]">
            {{ formatCountdown(rewardStore.countdownSeconds) }}
          </div>
        </div>

        <div class="dogactivity" @click="openWakdogModal" v-if="mineCountdown">
          <div class="countdown-overlay">
            <div class="countdown-text">{{ formattedCountdown }}</div>
          </div>
        </div>
      </div>
    </div>

  </div>
  <!-- <img :src="getAssetsFile('home/popCustomerServiceContainerIcon.png')" alt="" class="w-full h-full p-[100px]"> -->
</template>

<script setup lang="ts">
import { RedDot } from "@/components/RedDot";
import { Border } from "@/components/Border";
import { ref, onMounted, onUnmounted, watchEffect, nextTick, watch, computed } from "vue";
import * as GameApi from "@/api/game";
import { Button } from "@/components/Button";
import { languageColumns, locale } from "@/utils/i18n";
import dayjs from "dayjs";
import { useI18n } from "vue-i18n";
import { useRouter, useRoute } from "vue-router";
import {
  trackHomeClickBannerMain,
  trackHomeClickLoginButton,
  trackHomeClickMarquee,
  trackHomeClickMenuButton,
  trackHomeClickRegisterButton,
  trackHomeClickSearchButton,
  trackHomeClickCategoryTag,
  trackHomeClickFloatingWindow,
  trackHomeClickBannerSmall1,
  trackHomeClickBannerSmall2,
  trackHomeClickBannerSmall3,
  trackHomeClickGameEntryIcon,
} from "@/utils/firebase-analytics";
import { Ticker } from "@/components/Ticker";
import { getAssetsFile, downloadAPK, getUrlParam, getCookie, setCookie } from "@/utils/pub-use";
import { numberFormat } from "@/utils/formatter";
import {
  useUserStore,
  useMessageStore,
  useRewardStore,
  useAppStore,
  useVipStore,
} from "@/stores";
import { APKTracking } from "@/utils/event-tracking";
import { getDeviceInfo } from "@/utils/device";
import Game from "@/components/Game/index.vue";
// 添加 GlobalPopup 导入
import GlobalPopup from "@/components/GlobalPopup.vue";
// 添加 wakdog 组件导入
import wakdog from "@/pages/activity/components/wakdog.vue";
// 添加 firstExit 组件导入
import firstExit from "@/components/firstExit.vue";
// 添加 firstMentioned 组件导入
import firstMentioned from "@/components/firstMentioned.vue";
// 添加 RewardPopup 组件导入
import RewardPopup from "@/components/RewardPopup.vue";
// 添加 newswindows 组件导入
import newswindows from "@/components/newswindows.vue";
import { useStorage } from '@vueuse/core';
import { orderBy } from "lodash-es";
import {
  trackPromotionClickTreasureInvite,
  trackPromotionClickWheel,
  trackPromotionClickVip,
  trackPromotionClickAffiliate,
  trackPromotionClickRebate,
  trackPromotionClickRedEnvelope,
  trackPromotionClickDailyRescue,
  trackPromotionClickWeeklyRescue
} from '@/utils/firebase-analytics';
import { useActivityStore } from '@/stores/modules/activity';
import useUIStore from '@/stores/modules/ui';
import { getRechargeInfo, postRechargeConfirm } from '@/api/index';
import { trackRecharge, trackRegisterClick } from '@/utils/facebook-pixel-tracking';
const homePageRef = ref()
const uiStore = useUIStore();
const activityStore = useActivityStore();
const langs: any[] = languageColumns;
const VITE_IMG_URL = import.meta.env.VITE_IMG_URL;
const VITE_SYMBOL = import.meta.env.VITE_SYMBOL;
const IS_DOUBLE_WALLET = import.meta.env?.VITE_WALLET_SWITCH == 'true' ? true : false;
const appStore = useAppStore();
const rewardStore = useRewardStore();
const messageStore = useMessageStore();
const userStore = useUserStore();
const vipStore = useVipStore();
const activeVendor = ref(0);
const showLangSelect = ref(false);
const showDoubleWallet = ref(false);
const router = useRouter();
const route = useRoute();
const { t } = useI18n();
// 添加快捷活动弹窗显示状态
const quickActivityFlag = ref(true);
// 添加top图标显示状态
const showTopIcon = ref(false);
// 添加奖励弹窗状态
const showRewardPopup = ref(false);
// 添加弹窗显示状态
const showWakdogModal = ref(false);
// 侧边弹窗
const popFlag = ref(false);
const popIconAnimationOver = ref(false);
// 添加全局弹窗显示状态
const showPopup = ref(false);
// 添加 firstExit 弹窗相关状态
const showFirstExitModal = ref(false);
// 添加新闻弹窗显示状态
const showNewsWindows = ref(false);
// 添加新闻弹窗数据
const newsAccordionData = ref([

])
// 弹窗优先级
const popupPriority = ref(1); // 1=普通弹窗优先，2=列表弹窗优先
// 普通弹窗是否已关闭
const globalPopupClosed = ref(false);
// 列表弹窗是否已关闭
const newsPopupClosed = ref(false);
// 是否正在检查优先级，防止重复触发
const isCheckingPriority = ref(false);

// 获取弹窗优先级并显示第一个弹窗
const checkPopupPriority = async () => {
  // 防止重复触发
  if (isCheckingPriority.value) {
    console.log('正在检查优先级，跳过重复调用');
    return;
  }

  isCheckingPriority.value = true;
  console.log('开始检查弹窗优先级...');

  try {
    // 先确保两个弹窗都隐藏
    showPopup.value = false;
    showNewsWindows.value = false;

    const response = await GameApi.getPopupPriority();
    if (response && response.data && response.data.popupPriority !== undefined) {
      popupPriority.value = response.data.popupPriority;
      console.log('弹窗优先级:', popupPriority.value);

      // 等待一下确保弹窗完全隐藏
      await new Promise(resolve => setTimeout(resolve, 100));

      // 根据优先级显示第一个弹窗
      if (popupPriority.value === 1) {
        // 普通弹窗优先，先显示普通弹窗
        console.log('显示普通弹窗（优先级1）');
        showPopup.value = true;
      } else {
        // 列表弹窗优先，先显示列表弹窗
        console.log('显示列表弹窗（优先级2）');
        showNewsWindows.value = true;
      }
      isCheckingPriority.value = false;
    } else {
      // 如果接口返回失败，默认普通弹窗优先
      console.log('接口返回数据格式不正确，使用默认优先级');
      popupPriority.value = 1;
      await new Promise(resolve => setTimeout(resolve, 100));
      console.log('显示普通弹窗（默认优先级1）');
      showPopup.value = true;
      isCheckingPriority.value = false;
    }
  } catch (error) {
    console.error('获取弹窗优先级失败:', error);
    // 出错时默认普通弹窗优先
    popupPriority.value = 1;
    await new Promise(resolve => setTimeout(resolve, 100));
    console.log('显示普通弹窗（错误时默认优先级1）');
    showPopup.value = true;
    isCheckingPriority.value = false;
  }
};

// 监听普通弹窗关闭，显示下一个弹窗（包括自动关闭和手动关闭）
watch(() => showPopup.value, (newVal, oldVal) => {
  if (!newVal && oldVal && !globalPopupClosed.value) {
    // 普通弹窗关闭了（可能是用户手动关闭，也可能是没有数据自动关闭）
    globalPopupClosed.value = true;
    // 如果列表弹窗还没显示过，且优先级是普通弹窗优先，显示列表弹窗
    if (!newsPopupClosed.value && popupPriority.value === 1) {
      setTimeout(() => {
        showNewsWindows.value = true;
      }, 200);
    }
  }
});

// 监听列表弹窗关闭，显示下一个弹窗（包括自动关闭和手动关闭）
watch(() => showNewsWindows.value, (newVal, oldVal) => {
  if (!newVal && oldVal && !newsPopupClosed.value) {
    // 列表弹窗关闭了（可能是用户手动关闭，也可能是没有数据自动关闭）
    newsPopupClosed.value = true;
    // 如果普通弹窗还没显示过，且优先级是列表弹窗优先，显示普通弹窗
    if (!globalPopupClosed.value && popupPriority.value === 2) {
      setTimeout(() => {
        showPopup.value = true;
      }, 200);
    }
  }
});

// 处理新闻弹窗关闭
const handleNewsClose = (isChecked) => {
  console.log('新闻弹窗关闭，复选框状态：', isChecked);
  // watch 会处理显示下一个弹窗的逻辑
};
// 添加倒计时相关的响应式变量
const mineCountdown = ref(0); // 倒计时时间（秒）
const mineCountdownTimer = ref(null); // 倒计时定时器
// 添加首充弹窗金额
const firstExitAmount = ref("0");
// 添加首提弹窗显示状态
const showFirstMentionedModal = ref(false);
// 添加首提弹窗金额
const firstMentionedAmount = ref("0");

// 检查URL中的pid参数并处理
const checkPidParameter = () => {
  const pid = route.query.pid
  const jumpUrlType = route.query.jumpUrlType
  const channelId = route.query.channelId
  const channelName = route.query.channelName

  // 存储 channelId 和 channelName 到 cookie
  if (channelId) {
    setCookie('channelId', channelId as string)
    // 同时保存到 sessionStorage，供 downloadAPK 使用（保持向后兼容）
    sessionStorage.setItem('channelId', channelId as string)
  }

  if (channelName) {
    setCookie('channelName', channelName as string)
  }

  if (pid && !isLogin.value) {
    // 根据 jumpUrlType 决定是否立即弹出注册弹窗
    if (jumpUrlType === '2') {
      // jumpUrlType 为 2 时，立即弹出注册弹窗
      window.$showRegisterDialog(pid as string)
    } else if (jumpUrlType === '1') {
      // jumpUrlType 为 1 时，不弹出注册弹窗，但保存邀请码
      // 这里可以保存邀请码到 sessionStorage，供后续使用
      sessionStorage.setItem('inviteCode', pid as string)
      sessionStorage.setItem('jumpUrlType', jumpUrlType as string)
    } else {
      // 没有 jumpUrlType 参数时，保持原有逻辑
      window.$showRegisterDialog(pid as string)
    }
  }
}
// 下载横幅相关状态
const deviceInfo = getDeviceInfo();
const showDownloadBanner = ref(
  appStore.downloadOpen &&
  !window.platformGame &&
  (deviceInfo.isAndroid || (!deviceInfo.isMobile && !deviceInfo.isSafari))
);

const vipIconMap = ref(new Map());

// 厂商列表Dom对象
const vendorScrollRef = ref<HTMLElement | null>(null);

// 添加加载状态管理
const loadingStates = ref({
  games: false,
  userInfo: false,
  favorite: false,
  carousel: false,
  vendors: false,
});

// 游戏列表数据
const gameList = ref<any>({});

// 数据
const carouselChartList = ref<
  {
    position: number;
    picture: string;
    url: string;
    weight?: number;
  }[]
>([]);
// 添加侧边栏菜单数据
const sidebarMenuMaster = ref([
  {
    id: 1,
    icon: getAssetsFile("home/seraces (4).png"),
    title: 'popular',
    active: true,
  },
  {
    id: 2,
    icon: getAssetsFile("home/slotIcon.png"),
    title: "slot",
    type: "SLOTS",
    active: false,
  },
  {
    id: 4,
    icon: getAssetsFile("home/fishIcon.png"),
    title: "Fishing",
    type: "FISH",
    active: false,
  },
  // {
  //   id: 3,
  //   icon: getAssetsFile("home/cassinoIcon.png"),
  //   title: "Cassino",
  //   type: "Cassino",
  //   active: false,
  // },
  {
    id: 5,
    icon: getAssetsFile("home/cartasIcon.png"),
    title: "cards",
    type: "Cartas",
    active: false,
  },
  {
    id: 6,
    icon: getAssetsFile("game/VIDEO_on.png"),
    title: "Live",
    type: "LIVE",
    active: false,
  },

  // {
  //   id: 6,
  //   icon: getAssetsFile("home/jieJi.png"),
  //   title: "Arcades",
  //   type: "Arcades",
  //   active: false,
  // },
]);
// 热门游戏数据
const favoriteGames = ref([]);
// 首页厂商配置
const homeVendorGameConfig = ref([]);
// 厂商列表数据
const vendors = ref([]);
// banner数据
const bannderData = ref([]);
// 添加侧边栏banner数据
const sidebarBannerData = ref([]);
// 添加缓存机制，避免重复调用
const apiCache = new Map()
const turntableDataCache = ref(null)
const turntableDataCacheTime = ref(0)
const TURNTABLE_CACHE_DURATION = 30 * 1000 // 30秒缓存
// 缓存有效期
const CACHE_DURATION = 5 * 60 * 1000; // 5分钟缓存

const quickActivitys = ref([])
// 转盘次数
const turntableCount = ref(0);
// 宝箱可领取数量
const chestCount = ref(0);
// 神秘抽奖可领取数量
const mysteriousLotteryCount = ref(0);
// 更新宝箱红点状态
const updateChestBadge = () => {
  const hasBadge = chestCount.value > 0
  uiStore.setActivityBadge('chest', hasBadge)
}
// 添加防抖函数
const debounce = (func, wait) => {
  let timeout
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout)
      func(...args)
    }
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
  }
}
// 更新Eventos红点状态
const updateEventosBadge = () => {
  const hasBadge = turntableCount.value > 0
  uiStore.setActivityBadge('eventos', hasBadge)
}
const tabRefs = ref<HTMLElement[]>([]);
watch(activeVendor, (newVal) => {
  scrollToCenter(newVal)
})
const scrollToCenter = (index: number) => {
  const tabEls = tabRefs.value as HTMLElement[]
  const container = document.querySelector('.tab-container') as HTMLElement
  if (!tabEls || !container) return
  const tab = tabEls[index]
  if (!tab) return
  // 让当前tab居中
  const containerWidth = container.offsetWidth
  const tabLeft = tab.offsetLeft
  const tabWidth = tab.offsetWidth
  const scrollLeft = tabLeft - (containerWidth / 2) + (tabWidth / 2)
  container.scrollTo({ left: scrollLeft, behavior: 'smooth' })
}
const goToMensagenss = () => {
  trackHomeClickMarquee()
  if (!isLogin.value) {
    // 未登录情况下，设置标记只显示Support标签页
    sessionStorage.setItem('showOnlySupport', 'true')
    router.push('/mensagens')
    return
  }
  // 设置要显示的标签页索引（第二个标签页索引为1）
  sessionStorage.setItem('activeTabIndex', '1')
  router.push('/mensagens')
}
// 更新神秘抽奖红点状态
const updateMysteriousLotteryBadge = () => {
  const hasBadge = mysteriousLotteryCount.value > 0
  uiStore.setActivityBadge('mysterious', hasBadge)
}
// 获取神秘抽奖可领取数量的函数
const fetchMysteriousLotteryCount = async () => {
  try {
    const res = await GameApi.getMysteriousGoldActivity()

    if (res && res.data && res.data.appDayConfigs) {
      // 统计可领取的天数数量（claimReward为true的天数）
      mysteriousLotteryCount.value = res.data.appDayConfigs.filter(day => day.claimReward === true).length
    } else {
      mysteriousLotteryCount.value = 0
    }
    // 更新神秘抽奖红点状态
    updateMysteriousLotteryBadge()
  } catch (error) {
    console.error('获取神秘抽奖数据失败:', error)
    mysteriousLotteryCount.value = 0
    updateMysteriousLotteryBadge()
  }
};
// 获取转盘次数的函数
const fetchTurntableCount = async () => {
  try {
    await activityStore.getBasicFinancialData();
    turntableCount.value = activityStore.turntableCount;
    // 更新Eventos红点状态
    updateEventosBadge()
  } catch (error) {
    turntableCount.value = 0;
    updateEventosBadge()
  }
};
// 获取宝箱可领取数量的函数
const fetchChestCount = async () => {
  try {
    const params = {
      page: 1,
      pageSize: 100
    }
    const res = await GameApi.getPromoterBox(params)

    if (res && res.data && res.data.list) {
      // 统计状态为1（可领取）的宝箱数量
      chestCount.value = res.data.list.filter(chest => chest.status === 1).length
    } else {
      chestCount.value = 0
    }
    // 更新宝箱红点状态
    updateChestBadge()
  } catch (error) {
    console.error('获取宝箱数据失败:', error)
    chestCount.value = 0
    updateChestBadge()
  }
};
// 获取活动列表
const getActivityList = async () => {
  try {
    const res = await GameApi.activityList()

    // 对活动列表进行排序
    const sortedActivities = orderBy(res.data, ['sort', 'id'], ['desc', 'desc']).map(item => ({
      ...item,
      nametype: false,
      editData: {
        cn: '',
        en: ''
      }
    }))

    // 先设置活动列表数据
    quickActivitys.value = sortedActivities.filter(item => {
      return item.type != '自定义' && item.id != 24 && item.id != 28
    }).map(item => {
      return {
        ...item,
        img: JSON.parse(item.img)
      }
    })

    await fetchTurntableCount();
    await fetchChestCount();
    await fetchMysteriousLotteryCount();
  } catch (error) {
    console.error('获取活动列表失败:', error)

  }
};
const goMysteriousLottery = () => {
  router.push('/activity/components/MysteriousLottery')
}
// 判断是否应该显示镜头特效和红点
const shouldShowLensEffect = (item) => {
  // 转盘活动：ID为10且不是自定义类型
  if (item.id === 10 && item.type !== "自定义" && turntableCount.value > 0) {
    return true;
  }

  // 宝箱活动：ID为22且不是自定义类型
  if (item.id === 22 && item.type !== "自定义" && chestCount.value > 0) {
    return true;
  }

  // 神秘抽奖活动：ID为23且不是自定义类型
  if (item.id === 23 && item.type !== "自定义" && mysteriousLotteryCount.value > 0) {
    return true;
  }

  return false;
};
// 跳转活动页面
const goActivitys = (item) => {
  if (!isLogin.value) {
    window.$showLoginDialog();
    return
  }
  console.log('goActivity', item)
  // 先判断type，如果是自定义类型
  if (item.type === "自定义") {
    // 自定义活动也要判断是否有外部链接
    if (item.url !== null && item.url !== '') {
      // 判断是否是外部链接（http开头）
      if (item.url.startsWith('http')) {
        window.open(item.url, '_blank')
      } else {
        // 不是http开头，当作内部路由处理
        router.push(item.url)
      }
      return;
    }
    // 没有外部链接才跳转到自定义详情页
    router.push({
      path: '/activity/components/activityIndex/Custom',
      query: {
        info: item.info,
        name: item.name
      }
    })
    return;
  }

  // 非自定义活动：先判断外部链接
  if (item.url !== null && item.url !== '') {
    // 判断是否是外部链接（http开头）
    if (item.url.startsWith('http')) {
      window.open(item.url, '_blank')
    } else {
      // 不是http开头，当作内部路由处理
      router.push(item.url)
    }
    return;
  }

  // 根据id判断跳转路由（非自定义活动）
  switch (item.id) {
    case 12:
      trackPromotionClickDailyRescue()
      router.push('/activity/components/activityIndex/dailyCashback')
      break;
    case 22:
      trackPromotionClickTreasureInvite()
      router.push('/activity/components/activityIndex/indiqueAmigos')
      break;
    case 13:
      trackPromotionClickWeeklyRescue()
      router.push('/activity/components/activityIndex/weekCashback')
      break;
    case 10:
      trackPromotionClickWheel()
      router.push('/activity/components/activityIndex/turntable')
      break;
    case 9:
      trackPromotionClickRedEnvelope()
      router.push('/activity/components/activityIndex/Misteriosa')
      break;
    case 21:
      trackPromotionClickAffiliate()
      router.push('/activity/components/activityIndex/ComissaoDe')
      break;
    case 11:
      trackPromotionClickRebate()
      router.push({
        path: '/activity',
        query: {
          tab: 'rebate'
        }
      })
      break;
    case 14:
      trackPromotionClickVip()
      router.push('/activity/components/activityIndex/vipavtivity')
      break;
    case 23:
      goMysteriousLottery()
      break;
    case 24:
      router.push('/activity/components/activityIndex/entrada')
      break;
    case 27:
      router.push('/Deposito')
      break;
    default:
      router.push({
        path: '/activity/components/activityIndex/Custom',
        query: {
          info: item.info,
          name: item.name
        }
      })
  }
}

const pages = ref({
  favorite: {
    pageNo: 1,
    pageSize: 12,
    total: 0,
    hasMore: true,
  },
});
// 重置分页
const resetPage = () => {
  pages.value = {
    favorite: {
      pageNo: 1,
      pageSize: 12,
      total: 0,
      hasMore: true,
    },
  };
};
// 加载所有VIP图标（按需加载，只打包实际使用的图标）
const loadVipIcons = async () => {
  // 使用 eager: false，只打包实际调用了导入函数的图标
  const vipIconModules = import.meta.glob("@/assets/Vip/*.png", { eager: false });

  // 异步加载所有VIP图标模块
  const loadPromises = Object.entries(vipIconModules).map(async ([path, importFn]) => {
    try {
      // 调用导入函数，这会触发 Vite 打包该图标
      const module = await (importFn as () => Promise<any>)();

      // 从路径中提取VIP等级数字
      const fileName = path.split("/").pop()?.split(".").shift() || "";
      const vipLevel = fileName.replace("icon_vip", "");

      // 验证是否为有效数字
      if (!isNaN(Number(vipLevel))) {
        vipIconMap.value.set(Number(vipLevel), module.default || module);
      }
    } catch (error) {
      console.warn(`Failed to load VIP icon from ${path}:`, error);
    }
  });

  await Promise.all(loadPromises);
  console.log("已加载的VIP图标:", vipIconMap.value);
};
// 计算属性
const filteredCarouselList = computed(() => {
  return carouselChartList.value
    .filter((item) => (isLogin.value ? item.position === 2 : item.position === 1))
    .sort((a: { weight?: number; id?: number }, b: { weight?: number; id?: number }) => {
      // 首先按 weight 排序，weight 越低越靠前
      const weightDiff = (a.weight || 0) - (b.weight || 0);
      if (weightDiff !== 0) {
        return weightDiff;
      }
      // 如果 weight 相同，则按 id 排序
      return (b.id || 0) - (a.id || 0);
    });
});
/**
 * 格式化倒计时
 * @returns string
 */
const formattedCountdown = computed(() => {
  // 确保 mineCountdown.value 是有效数字
  if (
    typeof mineCountdown.value !== "number" ||
    isNaN(mineCountdown.value) ||
    mineCountdown.value < 0
  ) {
    return "00:00:00";
  }

  const hours = Math.floor(mineCountdown.value / 3600);
  const minutes = Math.floor((mineCountdown.value % 3600) / 60);
  const seconds = mineCountdown.value % 60;
  return `${hours.toString().padStart(2, "0")}:${minutes
    .toString()
    .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
});
const isLogin = computed(() => userStore.isLoggedIn);
// 添加 isLoggedIn 别名，保持兼容性
const walletFlag = useStorage('walletFlag', 'cash', sessionStorage);

const isLoggedIn = computed(() => userStore.isLoggedIn);
const cash = computed(() => {
  const walletInfos = userStore.userInfo.userWalletInfos;
  return walletInfos?.find((item: any) => item.currencyId != 3)?.availableAccount || '0';
});
const bonus = computed(() => {
  const walletInfos = userStore.userInfo.userWalletInfos;
  return walletInfos?.find((item: any) => item.currencyId == 3)?.availableAccount || '0';
})
const balance = computed(() => {
  if (walletFlag.value == 'cash') {
    return cash?.value || '0';
  } else {
    return bonus?.value || '0';
  }
})
const apkTracking = new APKTracking();
const reportRechargeToApk = ({ amount, currency, first }) => {
  if (window.jsBridge) {
    if (first) {
      apkTracking.trackFirstRecharge({
        amount,
        currency
      })
    } else {
      apkTracking.trackRecharge({
        amount,
        currency
      })
    }
  }
}
const reportRechargeToAdjust = ({ amount, currency, first }) => {
  if (window.$adjustTracking) {
    if (first) {
      window.$adjustTracking.trackFirstRecharge(
        amount,
        currency
      )
    } else {
      window.$adjustTracking.trackRecharge(
        amount,
        currency
      )
    }
  }
}
const reportRechargeToAppsFlyer = ({ amount, currency, first }) => {
  if (window.$appsFlyerTracking) {
    if (first) {
      window.$appsFlyerTracking.trackFirstRecharge(
        amount,
        currency
      )
    } else {
      window.$appsFlyerTracking.trackRecharge(
        amount,
        currency
      )
    }
  }
}
const reportRechargeToFb = ({ amount, currency, first }) => {
  trackRecharge(amount, currency, first)
}

const reportRecharge = () => {
  getRechargeInfo({}).then(async (res) => {
    if (res.data.length > 0) {

      for (let i = 0; i < res.data.length; i++) {
        const { amount, currency, first, orderId } = res.data[i]
        // 1、调用上报给马甲包的方法
        reportRechargeToApk({ amount, currency, first })
        // 2、上报给adjust
        reportRechargeToAdjust({ amount, currency, first })
        // 3、上报给appfplyers
        reportRechargeToAppsFlyer({ amount, currency, first })
        // 4、上报给fb
        reportRechargeToFb({ amount, currency, first })
        await postRechargeConfirm({
          orderIds: [orderId]
        })
        // 等待1秒上报
        await new Promise(resolve => setTimeout(resolve, 1000))
      }
    }
  }).catch(err => {
    console.log(err)
  })
}

watchEffect(() => {
  if (isLogin.value) {
    reportRecharge()
  }
})

// 方法
/**
 * 关闭下载横幅
 * @returns void
 */
const closeDownloadBanner = () => {
  console.log("closeDownloadBanner");
  showDownloadBanner.value = false;
};
/**
 * 下载APK
 * @returns void
 */
const handleInstall = () => {
  downloadAPK();
};
/**
 * 打开登录弹窗
 * @returns void
 */
const openLogin = () => {
  trackHomeClickLoginButton();
  // 获取邀请码
  const inviteCode = (route.query.pid as string) || "";
  window.$showLoginDialog(inviteCode); // 使用全局函数

  // 如果有保存的邀请码，可以在这里处理
  const savedInviteCode = sessionStorage.getItem("inviteCode");
  if (savedInviteCode) {
    // 可以将邀请码传递给登录弹窗
    console.log("使用保存的邀请码:", savedInviteCode);
  }
};
/**
 * 打开注册弹窗
 * @returns void
 */
const openRegister = () => {
  const inviteCode =
    (route.query.pid as string) || sessionStorage.getItem("inviteCode") || "";
  window.$showRegisterDialog(inviteCode);
  // 上报点击注册按钮事件
  const apkTracking = new APKTracking();
  apkTracking.trackRegisterClick();
  const adjustTracking = window.$adjustTracking;
  if (adjustTracking) {
    adjustTracking.trackRegisterClick();
  }
  const appsFlyerTracking = window.$appsFlyerTracking;
  if (appsFlyerTracking) {
    appsFlyerTracking.trackRegisterClick();
  }
  // fb
  if (typeof window.fbq === "function") {
    window.fbq("track", "RegisterClick");
  }
  trackHomeClickRegisterButton();
};

/**
 * 打开钱包
 * @returns void
 */
const openWallet = () => {
  if (!isLogin.value) {
    // 未登录时，检查是否有 jumpUrlType 参数
    const jumpUrlType = route.query.jumpUrlType || sessionStorage.getItem('jumpUrlType')

    if (jumpUrlType === '1') {
      // jumpUrlType 为 1 时，用户点击钱包时弹出注册弹窗
      window.$showRegisterDialog()
    } else {
      // 其他情况，弹出登录弹窗
      window.$showLoginDialog()
    }
  } else {
    // 已登录时，正常跳转到钱包页面
    sessionStorage.setItem('fromHome', 'true')
    router.push('/Deposito')
  }
}
/**
 * 跳转到消息中心
 * @returns void
 */
const goToMensagens = () => {
  trackHomeClickMarquee();
  if (!isLogin.value) {
    // 未登录情况下，设置标记只显示Support标签页
    sessionStorage.setItem('showOnlySupport', 'true')
  }

  // sessionStorage.setItem("activeTabIndex", "0");
  router.push("/mensagens");
};

/**
 * 从客服图标跳转到消息中心
 * @returns void
 */
const goToMensagensFromKefus = () => {
  if (!isLogin.value) {
    // 未登录情况下，设置标记只显示Support标签页
    sessionStorage.setItem('showOnlySupport', 'true')
  }
  router.push('/mensagens')
}
/**
 * @param item 轮播图数据
 * @returns void
 */
const goBanner = (item) => {
  trackHomeClickBannerMain();
  router.push(item.url);
};
/**
 * 获取轮播图数据
 * @returns void
 */
const carouselChart = async () => {
  const cacheKey = "carouselChart";
  const cached = apiCache.get(cacheKey);

  // 检查缓存是否有效
  if (cached && Date.now() - cached.timestamp < CACHE_DURATION) {
    carouselChartList.value = cached.data;
    return;
  }

  const data = await GameApi.carouselChart();
  carouselChartList.value = data.data;

  // 缓存数据
  apiCache.set(cacheKey, {
    data: data.data,
    timestamp: Date.now(),
  });
};
/**
 * 获取首页配置项
 */
const getBannerData = async () => {
  let res = await GameApi.getRightLst();
  bannderData.value = res.data;
  // 复用轮播图数据，避免重复请求
  if (carouselChartList.value.length > 0) {
    sidebarBannerData.value = carouselChartList.value.filter(
      (item) => item.position === 7
    );
  } else {
    // 如果缓存为空，才请求
    try {
      const bannerRes = await GameApi.carouselChart();

      // 过滤出 position 为 7 的数据
      sidebarBannerData.value = bannerRes.data.filter((item) => item.position === 7);
    } catch (error) { }
  }
};

// getAllList 函数，保持与 index1.vue 的一致性
const getAllList = async () => {
  let res = await GameApi.getRightLst();
  bannderData.value = res.data;
  console.log(bannderData.value = res.data, '首页配置项');

  // 复用轮播图数据，避免重复请求
  if (carouselChartList.value.length > 0) {
    sidebarBannerData.value = carouselChartList.value.filter(item => item.position === 7);
    console.log('使用缓存的侧边栏banner数据:', sidebarBannerData.value);
  } else {
    // 如果缓存为空，才请求
    try {
      const bannerRes = await GameApi.carouselChart();
      console.log('banner接口返回数据:', bannerRes.data);
      // 过滤出 position 为 7 的数据
      sidebarBannerData.value = bannerRes.data.filter(item => item.position === 7);
      console.log('过滤后的侧边栏banner数据:', sidebarBannerData.value);
    } catch (error) {
      console.error('获取侧边栏banner数据失败:', error);
    }
  }
};
/**
 * 点击首页配置项
 * @param e 首页配置项数据
 * @param index 索引
 * @returns void
 */
const goActivity = (e, index) => {
  switch (index) {
    case 0:
      trackHomeClickBannerSmall1();
      break;
    case 1:
      trackHomeClickBannerSmall2();
      break;
    case 2:
      trackHomeClickBannerSmall3();
      break;
  }

  // 检查是否需要登录的页面
  if (e.jumpUrl) {
    // 解析URL，提取路径部分（支持相对路径和绝对路径）
    let urlPath = e.jumpUrl;
    try {
      // 如果是完整URL，提取路径部分
      if (urlPath.startsWith('http://') || urlPath.startsWith('https://')) {
        const urlObj = new URL(urlPath);
        urlPath = urlObj.pathname + urlObj.search;
      }
    } catch (error) {
      // 如果不是完整URL，直接使用原值
      urlPath = e.jumpUrl;
    }

    // 检查是否是跳转到需要登录的页面
    // 包括：/activity?tab=vip、/Deposito、/wallet、推广页（/ConvidarCentro）
    const needLogin =
      (urlPath === '/activity?tab=vip' || urlPath.includes('/activity?tab=vip')) ||
      (urlPath === '/Deposito' || urlPath.startsWith('/Deposito')) ||
      (urlPath === '/wallet' || urlPath.startsWith('/wallet')) ||
      (urlPath === '/ConvidarCentro' || urlPath.startsWith('/ConvidarCentro')); // 推广页需要登录

    // 如果需要登录且用户未登录，弹出登录弹窗，登录后再跳转
    if (needLogin && !isLogin.value) {
      // 保存要跳转的URL（使用原始URL）
      sessionStorage.setItem('pending_activity_vip_redirect', e.jumpUrl);
      // 获取邀请码
      const inviteCode = (route.query.pid as string) || "";
      // 弹出登录弹窗
      window.$showLoginDialog(inviteCode);
      return; // 不执行跳转，等待登录
    }
  }

  if (e.jumpType == 0) {
    router.push(e.jumpUrl);
  } else {
    window.location.href = e.jumpUrl;
  }
};
/**
 * 搜索按钮点击事件
 * @returns void
 */
const handleSearch = () => {
  trackHomeClickSearchButton();
  router.push("/search");
};
/**
 * 获取厂商列表
 */
const getVendors = async () => {
  loadingStates.value.vendors = true;
  const res = await GameApi.ListaDEFabricantes();
  vendors.value = res.data;
  loadingStates.value.vendors = false;
};
/**
 * 厂商翻到下一页
 */
const vendorNextPage = () => {
  if (vendorScrollRef.value) {
    vendorScrollRef.value.scrollLeft += vendorScrollRef.value.offsetWidth;
  }
};

const getTypeIcon = (categoryCode) => {
  // 根据 categoryCode 返回不同icon
  // 老虎机
  if (categoryCode === "SLOTS") return getAssetsFile("game/777.png");
  // 棋牌
  if (categoryCode === "CHESS") return getAssetsFile("game/kaipis.png");
  // 捕鱼
  if (categoryCode === "FISH") return getAssetsFile("game/jingyus.png");
  // 真人
  if (categoryCode === "LIVE") return getAssetsFile("game/bofans.png");
  // 街机
  if (categoryCode === "ARCADES") return getAssetsFile("game/jieJi.png");
  // 彩票
  if (categoryCode === "HALL") return getAssetsFile("game/kaipis.png");
  // 视讯
  if (categoryCode === "VIDEO_GAME") return getAssetsFile("game/bofans.png");
};
/**
 * 点击厂商按钮
 * @param item 厂商数据
 * @returns void
 */
const handleVendorClick = async (item, index) => {
  activeVendor.value = (index + 1)
  favoriteGames.value = [];
  homeVendorGameConfig.value = []
  trackHomeClickCategoryTag();
  resetPage();
  const vendorId = item.id; // 保存厂商ID，避免变量名冲突
  const res = await GameApi.getVendorGameInfo({ vendorId: vendorId });

  // 先获取分类列表和统计信息
  const categoryList = Object.keys(res.data.vendorGames).map((categoryCode, index) => {
    const vendorItem = res.data?.vendorGameCountList?.find(
      (items) => items.categoryCode === categoryCode
    )

    if (!pages.value[categoryCode]) {
      pages.value[categoryCode] = {
        pageNo: 1,
        pageSize: 12,
        total: vendorItem?.count || 0,
        hasMore: vendorItem?.count > 12 ? true : false,
      };
    } else {
      pages.value[categoryCode].total = vendorItem?.count || 0;
    }

    return {
      categoryCode,
      vendorItem,
      index,
    };
  });

  // 并行获取每个分类的第一页完整数据（包含 tag 字段）
  const gameDataPromises = categoryList.map(async ({ categoryCode, vendorItem, index }) => {
    try {
      // 调用 getHomeVendorGameConfig 获取完整数据（包含 tag 字段）
      const gameRes = await getHomeVendorGameConfig(
        {
          vendorId: vendorId,
          type: categoryCode,
        },
        1,
        12
      );

      const obj = {
        img: getTypeIcon(categoryCode),
        id: categoryCode,
        type: categoryCode,
        sort: vendorItem?.sort || index,
        games: gameRes.list || [], // 使用包含 tag 字段的完整数据
        vendorId: vendorId,
      };

      // 同步更新 gameList.value.gameMap
      if (gameList.value && gameList.value.gameMap) {
        gameList.value.gameMap[`${categoryCode}`] = gameRes.list || [];
      }
      // 同步更新 gameList.value.gameCountMap
      if (gameList.value && !gameList.value.gameCountMap) {
        gameList.value.gameCountMap = {};
      }
      if (gameList.value && gameList.value.gameCountMap) {
        gameList.value.gameCountMap[`${categoryCode}`] = vendorItem?.count || 0;
      }

      return obj;
    } catch (error) {
      console.error(`获取分类 ${categoryCode} 的游戏数据失败:`, error);
      // 如果获取失败，使用 getVendorGameInfo 返回的数据作为后备
      const games = res.data.vendorGames[categoryCode] || [];
      return {
        img: getTypeIcon(categoryCode),
        id: categoryCode,
        type: categoryCode,
        sort: vendorItem?.sort || index,
        games: games,
        vendorId: vendorId,
      };
    }
  });

  // 等待所有请求完成
  const list = await Promise.all(gameDataPromises);
  console.log(list, "homeVendorGameConfig.value");
  homeVendorGameConfig.value = orderBy(list, ['sort'], ['desc']);


};
/**
 * 获取收藏游戏
 * @param item 游戏数据
 * @returns void
 */
const getFavoriteGames = async (vendor?: any) => {
  try {
    loadingStates.value.favorite = true;
    const res = await GameApi.collectList(pages.value.favorite);
    favoriteGames.value = res.data.list || [];
    pages.value.favorite.total = res.data.total;
  } finally {
    loadingStates.value.favorite = false;
  }
};
/**
 * 获取首页厂商配置
 * 等同于 index1.vue 中的热门游戏逻辑，使用 gameList.value.vendorManagerList
 * 与 index1.vue 保持一致，不使用 getHomeColumnList()
 * @returns void
 */
const getHomeVendorConfig = async () => {
  activeVendor.value = 0
  resetPage();
  getFavoriteGames();
  await loadGameList();
  homeVendorGameConfig.value = []
  // 使用 gameList.value.vendorManagerList 的数据，与 index1.vue 中的热门游戏逻辑一致
  if (gameList.value && gameList.value.vendorManagerList && gameList.value.vendorManagerList.length > 0) {
    // 并行获取每个分类的第一页数据，确保获取最新的收藏状态
    const gameDataPromises = gameList.value.vendorManagerList.map(async (item, index) => {
      // 初始化分页信息
      if (!pages.value[item.id]) {
        const total = gameList.value.gameCountMap?.[item.id] || 0;
        pages.value[item.id] = {
          pageNo: 1,
          pageSize: 12,
          total: total,
          hasMore: total > 12,
        };
      }

      try {
        // 重新请求第一页数据，获取最新的收藏状态
        const gameRes = await getHomeVendorGameConfig(
          {
            vendorId: item.vendorId,
            type: item.categoryCode,
          },
          1,
          12
        );

        // 更新分页信息
        pages.value[item.id] = {
          ...pages.value[item.id],
          total: gameRes.total,
          hasMore: gameRes.hasMore,
        };

        // 同步更新 gameList.value.gameMap
        if (gameList.value && gameList.value.gameMap) {
          gameList.value.gameMap[`${item.id}`] = gameRes.list || [];
        }

        return {
          id: item.id,
          vendorId: item.vendorId,
          icon: item.icon,
          categoryCode: item.categoryCode,
          type: item.categoryCode,
          games: gameRes.list || [], // 使用最新请求的数据，包含最新的收藏状态
        };
      } catch (error) {
        console.error(`获取分类 ${item.categoryCode} 的游戏数据失败:`, error);
        // 如果请求失败，使用缓存数据作为后备
        const games = gameList.value.gameMap?.[item.id] || [];
        return {
          id: item.id,
          vendorId: item.vendorId,
          icon: item.icon,
          categoryCode: item.categoryCode,
          type: item.categoryCode,
          games: games,
        };
      }
    });

    // 等待所有请求完成
    const list = await Promise.all(gameDataPromises);
    homeVendorGameConfig.value = list;
  }
};
/**
 * 根据厂商获取游戏
 */
const getHomeVendorGameConfig = async (
  vendor: {
    createTime?: number;
    icon?: string;
    id?: number;
    providerId?: number;
    sort?: number;
    type?: string;
    vendorId?: number | null;
    vendorName?: string;
  },
  pageNo: number,
  pageSize: number
) => {
  const res = await GameApi.thirdPartyGame({
    vendorId: vendor.vendorId ? Number(vendor.vendorId) : undefined,
    categoryCode: vendor.type,
    pageNo: pageNo,
    pageSize: pageSize,
  });
  const total = res.data.total || 0;
  const hasMore = pageNo * pageSize < total;
  return {
    total: total,
    list: res.data.list,
    hasMore: hasMore,
  };
};
/**
 * 游戏列表翻到上一页
 */
const gameListPrevPage = async (item: any) => {
  if (pages.value[item.id].pageNo > 1) {
    pages.value[item.id].pageNo--;

    const vendor = vendors.value[activeVendor.value - 1];
    const res = await getHomeVendorGameConfig(
      {
        vendorId: vendor?.id || item.vendorId,
        type: item.type,
      },
      pages.value[item.id].pageNo,
      pages.value[item.id].pageSize
    );
    pages.value[item.id] = {
      ...pages.value[item.id],
      hasMore: res.hasMore,
      total: res.total,
    };
    // 同步更新 gameList.value.gameMap
    if (gameList.value && gameList.value.gameMap && vendor) {
      gameList.value.gameMap[`${item.id}`] = res.list;
      // 如果使用 gameList.value.vendorManagerList 的数据，需要从 gameMap 同步更新
      item.games = gameList.value.gameMap[`${item.id}`] || res.list;
    } else {
      item.games = res.list;
    }

  }
};
/**
 * 游戏列表翻到下一页
 */
const gameListNextPage = async (item: any) => {

  if (!pages.value[item.id].hasMore) return;
  pages.value[item.id].pageNo++;
  const vendor = vendors.value[activeVendor.value - 1];
  const res = await getHomeVendorGameConfig(
    {
      vendorId: vendor?.id || item?.vendorId,
      type: item?.type,
    },
    pages.value[item.id].pageNo,
    pages.value[item.id].pageSize
  );

  item.games = res.list;
  pages.value[item.id] = {
    ...pages.value[item.id],
    hasMore: res.hasMore,
    total: res.total,
  };
  // 同步更新 gameList.value.gameMap
  if (gameList.value && gameList.value.gameMap && vendor) {
    gameList.value.gameMap[`${item.id}`] = res.list;
  }
  // 如果使用 gameList.value.vendorManagerList 的数据，需要从 gameMap 同步更新
  if (gameList.value && gameList.value.gameMap && vendor) {
    vendor.games = gameList.value.gameMap[`${item.id}`] || res.list;
  }
};
/**
 * 分批加载所有游戏数据（接口最大 pageSize 为 100）
 */
const loadAllGames = async (item: any) => {
  const total = pages.value[item.id]?.total || 0;
  if (total <= 0) return;

  // 如果已经在加载中，防止重复加载
  if (loadingStates.value.games) return;

  // 如果已经加载了所有数据，直接返回
  if (pages.value[item.id]?.pageSize >= total) return;

  // 设置加载状态
  loadingStates.value.games = true;

  try {
    const MAX_PAGE_SIZE = 100; // 接口最大 pageSize
    const allGames: any[] = [];
    const vendor = vendors.value[activeVendor.value - 1];
    // 如果 total <= 100，直接加载一次即可
    if (total <= MAX_PAGE_SIZE) {

      const res = await getHomeVendorGameConfig({
        vendorId: vendor?.id || item.vendorId,
        type: item.type,
      }, 1, MAX_PAGE_SIZE);
      if (res.list && res.list.length > 0) {
        allGames.push(...res.list);
      }
    } else {
      // 如果 total > 100，分批加载
      let currentPage = 1;
      let hasMore = true;
      const maxPages = Math.ceil(total / MAX_PAGE_SIZE);

      // 分批加载，每次最多 100 条
      while (hasMore && allGames.length < total && currentPage <= maxPages) {
        const res = await getHomeVendorGameConfig(
          {
            vendorId: vendor?.id || item.vendorId,
            type: item.type,
          },
          currentPage,
          MAX_PAGE_SIZE
        );

        if (res.list && res.list.length > 0) {
          allGames.push(...res.list);
        }

        // 检查是否还有更多数据
        hasMore = res.hasMore && allGames.length < total;
        currentPage++;
      }
    }

    // 更新分页信息
    pages.value[item.id] = {
      ...pages.value[item.id],
      pageNo: 1,
      pageSize: total, // 设置为 total，表示已加载全部
      total: total,
      hasMore: false,
    };

    // 同步更新 gameList.value.gameMap
    if (gameList.value && gameList.value.gameMap) {
      gameList.value.gameMap[`${item.id}`] = allGames;
      item.games = allGames;
    } else {
      item.games = allGames;
    }

    getFavoriteGames();
  } catch (error) {
    console.error('分批加载游戏数据失败:', error);
    // 加载失败时，保持原有数据不变
  } finally {
    loadingStates.value.games = false;
  }
};
const updateGame = async (game: any) => {
  // 获取当前选中的厂商信息，用于传递 vendorId
  game.collect = !game.collect;
  if (activeVendor.value == 0) {
    getFavoriteGames();
  } else {
    favoriteGames.value = []
  }
};
/**
 * 更新游戏
 */
const updatePageGame = async (item: any) => {
  // 获取当前选中的厂商信息，用于传递 vendorId
  const vendor = activeVendor.value > 0 ? vendors.value[activeVendor.value - 1] : null;
  const res = await getHomeVendorGameConfig(
    {
      vendorId: vendor?.id || item.vendorId,
      type: item.type,
    },
    pages.value[item.id].pageNo,
    pages.value[item.id].pageSize
  );
  pages.value[item.id] = {
    ...pages.value[item.id],
    hasMore: res.hasMore,
    total: res.total,
  };
  // 同步更新 gameList.value.gameMap
  if (gameList.value && gameList.value.gameMap) {
    // 确保 gameMap 存在
    if (!gameList.value.gameMap) {
      gameList.value.gameMap = {};
    }
    gameList.value.gameMap[`${item.id}`] = res.list;
    // 如果使用 gameList.value.vendorManagerList 的数据，需要从 gameMap 同步更新
    item.games = gameList.value.gameMap[`${item.id}`] || res.list;
  } else {
    item.games = res.list;
  }
  if (activeVendor.value == 0) {
    getFavoriteGames();
  }

};
/**
 * 跳转到客服
 * @returns void
 */
const goCustomerService = () => {
  goToMensagensFromKefus();
};
/**
 * 滚动到顶部
 * @returns void
 */
const scrollToTop = () => {
  homePageRef.value?.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};
/**
 * 打开奖励弹窗
 * @returns void
 */
const openRewardPopup = () => {
  if (rewardStore.status === 0) {
    showRewardPopup.value = true;
  }
};

// 获取新用户专属奖励数据
const getNewUserExclusive = async (forceRefresh = false) => {
  try {
    // 检查缓存是否有效
    const now = Date.now()
    if (!forceRefresh && turntableDataCache.value && (now - turntableDataCacheTime.value) < TURNTABLE_CACHE_DURATION) {
      console.log('使用缓存的新用户专属奖励数据:', turntableDataCache.value)
      return turntableDataCache.value
    }

    const response = await GameApi.userTurntable()
    console.log('新用户专属奖励数据:', response.data)

    // 检查响应数据是否有效
    if (response && response.data) {
      // 更新缓存
      turntableDataCache.value = response.data
      turntableDataCacheTime.value = now
      console.log(response.data, "response.data")
      // 将数据存储到store中
      rewardStore.setNewUserExclusiveData(response.data)

      // 返回数据供其他函数使用
      return response.data
    } else {
      console.warn('新用户专属奖励数据为空')
      return null
    }
  } catch (error) {
    console.error('获取新用户专属奖励失败:', error)
    return null
  }
}

// 检查新用户转盘抽奖状态
const checkNewUserTurntableStatus = async (turntableData = null) => {
  console.log('=== 开始检查新用户转盘状态 ===')
  console.log('当前登录状态:', isLogin.value)
  console.log('当前路由:', route.path)

  // 检查是否刚完成抽奖返回首页，如果是则跳过检查
  const justCompleted = sessionStorage.getItem('just_completed_turntable')
  if (justCompleted === 'true') {
    console.log('检测到刚完成抽奖返回首页，跳过检查')
    sessionStorage.removeItem('just_completed_turntable')
    return
  }

  // 如果已登录，先检查活动状态
  if (isLogin.value) {
    try {
      let responseData = turntableData

      // 如果没有传入数据，优先使用缓存，避免重复调用API
      if (!responseData) {
        // 先检查缓存
        if (turntableDataCache.value) {
          console.log('使用缓存的数据进行转盘状态检查:', turntableDataCache.value)
          responseData = turntableDataCache.value
        } else {
          console.log('缓存为空，调用getNewUserExclusive获取数据...')
          responseData = await getNewUserExclusive()
        }
      } else {
        console.log('使用已获取的数据:', responseData)
      }

      console.log('response.data.status:', responseData?.status)

      // 检查活动是否开启 - 如果data为null，说明活动未开启
      if (!responseData || responseData === null) {
        console.log('活动未开启，不跳转到抽奖页面')
        // 清除新注册用户标记，避免下次检查时再次弹出
        const isNewUser = sessionStorage.getItem('isNewUser')
        if (isNewUser === 'true') {
          console.log('活动未开启，清除新注册用户标记')
          sessionStorage.removeItem('isNewUser')
        }
        return
      }

      // 检查是否是新注册用户（sessionStorage中的标记）
      const isNewUser = sessionStorage.getItem('isNewUser')
      console.log('sessionStorage中的isNewUser:', isNewUser)

      // 检查是否已经跳过抽奖页面（防止死循环）
      const userId = userStore.userInfo?.id
      const skipTurntableKey = `skip_turntable_${userId}`
      const hasSkippedTurntable = sessionStorage.getItem(skipTurntableKey) === 'true'

      if (isNewUser === 'true' && !hasSkippedTurntable) {
        console.log('检测到新注册用户且活动已开启，跳转到转盘页面')
        sessionStorage.removeItem('isNewUser')
        router.push('/activity/components/activityIndex/newUsers')
        return
      } else if (isNewUser === 'true' && hasSkippedTurntable) {
        console.log('新注册用户已跳过抽奖页面，清除新用户标记')
        sessionStorage.removeItem('isNewUser')
      }

      // 检查是否已经抽过奖
      // 使用多个字段综合判断用户是否已经抽过奖
      const turntableCompletedKey = `turntable_completed_${userId}`
      const isCompletedInLocalStorage = localStorage.getItem(turntableCompletedKey) === 'true'

      // 后端状态：0=未领取，1=已领取，2=已过期
      const backendStatus = responseData?.status
      const rewardAmount = responseData?.rewardAmount
      const expiredTime = responseData?.expiredTime

      // 综合判断：如果用户有奖励金额或倒计时时间，说明已经抽过奖
      const hasRewardData = (rewardAmount && rewardAmount > 0) || (expiredTime && expiredTime > 0)
      const isCompletedInBackend = backendStatus === 1 || backendStatus === 2 || hasRewardData

      console.log('详细判断信息:', {
        rewardAmount,
        expiredTime,
        rewardAmountType: typeof rewardAmount,
        expiredTimeType: typeof expiredTime,
        rewardAmountCheck: rewardAmount && rewardAmount > 0,
        expiredTimeCheck: expiredTime && expiredTime > 0,
        hasRewardData,
        isCompletedInBackend
      })

      console.log('抽奖状态判断:', {
        userId,
        turntableCompletedKey,
        isCompletedInLocalStorage,
        skipTurntableKey,
        hasSkippedTurntable,
        backendStatus,
        rewardAmount,
        expiredTime,
        hasRewardData,
        isCompletedInBackend
      })

      // 如果后端显示已完成，但 localStorage 没有标记，同步 localStorage
      if (isCompletedInBackend && !isCompletedInLocalStorage) {
        console.log('后端显示已完成，同步 localStorage 状态')
        localStorage.setItem(turntableCompletedKey, 'true')
      }

      // 只有后端显示未完成且 localStorage 也没有完成标记且没有跳过标记时，才跳转
      if (!isCompletedInBackend && !isCompletedInLocalStorage && !hasSkippedTurntable) {
        console.log('新用户未完成转盘抽奖，跳转到转盘页面')
        // 设置跳过标记，防止从抽奖页面返回时再次跳转
        sessionStorage.setItem(skipTurntableKey, 'true')
        router.push('/activity/components/activityIndex/newUsers')
        return
      } else {
        console.log('用户已完成转盘抽奖或已跳过，不跳转')
        // 如果用户确实未抽奖但被跳过标记阻止，清除跳过标记
        if (!isCompletedInBackend && !isCompletedInLocalStorage && hasSkippedTurntable) {
          console.log('检测到用户未抽奖但被跳过标记阻止，清除跳过标记')
          sessionStorage.removeItem(skipTurntableKey)
        }
      }
    } catch (error) {
      console.error('检查新用户转盘状态失败:', error)
    }
  } else {
    console.log('用户未登录，跳过新用户转盘状态检查')
  }

  console.log('=== 新用户转盘状态检查完成 ===')
}
/**
 * 格式化倒计时
 * @param seconds 秒
 * @returns string
 */
const formatCountdown = (seconds: number) => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;

  return `${hours.toString().padStart(2, "0")}:${minutes
    .toString()
    .padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
};

// 首页倒计时相关
let homeCountdownTimer: NodeJS.Timeout | null = null;

// 开始首页倒计时
const startHomeCountdown = () => {
  if (homeCountdownTimer) {
    clearInterval(homeCountdownTimer);
  }

  homeCountdownTimer = addTimer(() => {
    if (rewardStore.countdownSeconds > 0) {
      rewardStore.updateCountdown(rewardStore.countdownSeconds - 1);
    } else {
      // 倒计时结束
      clearInterval(homeCountdownTimer);
      homeCountdownTimer = null;
    }
  }, 1000);
};

// 停止首页倒计时
const stopHomeCountdown = () => {
  if (homeCountdownTimer) {
    clearInterval(homeCountdownTimer);
    homeCountdownTimer = null;
  }
};

// 优化后的滚动检测函数 - 使用防抖和requestAnimationFrame
const handleScrollInternal = () => {

  // 使用 requestAnimationFrame 优化性能
  requestAnimationFrame(() => {
    if (!homePageRef.value) return

    // 计算页面滚动比例 - 使用DOM元素的属性
    const scrollTop = homePageRef.value.scrollTop
    const clientHeight = homePageRef.value.clientHeight
    const scrollHeight = homePageRef.value.scrollHeight
    const scrollRatio = scrollHeight > clientHeight ? scrollTop / (scrollHeight - clientHeight) : 0

    // 当滚动超过一半时显示top图标
    showTopIcon.value = scrollRatio > 0.5
  })
}

// 使用防抖的滚动处理函数
const handleScroll = debounce(handleScrollInternal, 100)

// 修改检查首充返利的函数
const checkFirstRechargeRebate = async () => {
  // 只在已登录时检查
  if (isLogin.value) {
    try {
      console.log('检查首充返利状态:', userStore.userInfo.firstRechargeRebate)
      console.log('检查首提返利状态:', (userStore.userInfo as any).firstWithdrawRebate)

      // 先检查首充返利状态
      if (userStore.userInfo.firstRechargeRebate === true) {
        // 设置弹窗金额（这里可以根据实际需求设置）
        firstExitAmount.value = '0' // 示例金额，可以根据实际需求调整
        showFirstExitModal.value = true
        console.log('显示首充返利弹窗')

        // 如果首充返利为 true，不检查首提返利，等待首充弹窗流程完成
        return
      }

      // 如果首充返利不为 true，检查首提返利
      if ((userStore.userInfo as any).firstWithdrawRebate === true) {
        firstMentionedAmount.value = '0' // 示例金额，可以根据实际需求调整
        showFirstMentionedModal.value = true
        console.log('显示首提返利弹窗')
      }

    } catch (error) {
      console.error('检查首充返利失败:', error)
    }
  }
}

// 添加检查首提返利的函数 - 在路由监听中调用
const checkFirstMentionedRebate = async () => {
  // 只在已登录时检查
  if (isLogin.value) {
    try {
      // 确保用户信息是最新的
      await userStore.info()

      // 检查首提返利状态
      if ((userStore.userInfo as any).firstWithdrawRebate === true) {
        firstMentionedAmount.value = '0'
        showFirstMentionedModal.value = true
      }
    } catch (error) {
      console.error('检查首提返利失败:', error)
    }
  }
}
/**
 * 打开Wakdog弹窗
 * @returns void
 */
const openWakdogModal = () => {
  trackHomeClickFloatingWindow();
  showWakdogModal.value = true;
};
/**
 * 关闭Wakdog弹窗
 * @returns void
 */
const closeWakdogModal = () => {
  showWakdogModal.value = false;
};
/**
 * 确认首充返利
 * @returns void
 */
const confirmFirstExit = () => {
  showFirstExitModal.value = false;
  // 不再设置 sessionStorage 标志，让用户信息状态来控制
};
/**
 * 关闭首充返利弹窗
 * @returns void
 */
const closeFirstExitModal = () => {
  showFirstExitModal.value = false;
  // 不再设置 sessionStorage 标志，让用户信息状态来控制
};
/**
 * 关闭首提返利弹窗
 * @returns void
 */
const closeFirstMentionedModal = () => {
  showFirstMentionedModal.value = false;
  // 不再设置 sessionStorage 标志，让用户信息状态来控制
};
/**
 * 关闭奖励弹窗
 * @returns void
 */
const closeRewardPopup = () => {
  showRewardPopup.value = false;
  // 不再设置 sessionStorage 标志，让用户信息状态来控制
};
/**
 * 放弃奖励
 * @returns void
 */
const handleAbandonReward = () => {
  showRewardPopup.value = false;
  // 这里不需要额外处理，因为 RewardPopup 组件已经调用了 rewardStore.clearData()
};
/**
 * 切换菜单
 * @param item 菜单项
 * @returns void
 */
const toggleMenu = (item: any) => {
  if (!item.type) {
    router.push("/Search");
  } else {
    item.active = true;
    router.push({
      name: "findGameByVendor",
      query: {
        item: JSON.stringify(item),
      },
    });
  }
};

/**
 * 切换主菜单
 * @param item 菜单项
 * @returns void
 */
const toggleMenuMaster = (item: any) => {
  router.push('/Search')
}
/**
 * 跳转到投注记录
 * @returns void
 */
const goBetRecord = () => {
  router.push("/relatorios");
};

// 跳转相关函数
const gobaoxiang = () => {
  const a = userStore.checkLoginStatus()
  if (a) {
    router.push('/activity/components/activityIndex/indiqueAmigos')
  } else {
    window.$showLoginDialog()
  }
}

const gofiles = () => {
  const a = userStore.checkLoginStatus()
  if (a) {
    router.push('/activity/components/activityIndex/ComissaoDe')
  } else {
    window.$showLoginDialog()
  }
}

const gozhang = () => {
  const a = userStore.checkLoginStatus()
  if (a) {
    router.push('/relatorios')
  } else {
    window.$showLoginDialog()
  }
}

const gosoon = () => {
  window.$toast('coming soon')
}
/**
 * 处理侧边栏banner点击
 * @param item 点击项
 * @returns void
 */
const handleSidebarBannerClick = (item) => {
  if (!item.url) return;

  // 判断是否为外部链接
  if (item.url.startsWith("http://") || item.url.startsWith("https://")) {
    // 外部链接，用浏览器打开新页面
    window.open(item.url, "_blank");
    return;
  }

  // 内部路由，检查是否需要登录
  // 解析URL，提取路径部分（支持相对路径和绝对路径）
  let urlPath = item.url;
  try {
    // 如果是完整URL，提取路径部分
    if (urlPath.startsWith('http://') || urlPath.startsWith('https://')) {
      const urlObj = new URL(urlPath);
      urlPath = urlObj.pathname + urlObj.search;
    }
  } catch (error) {
    // 如果不是完整URL，直接使用原值
    urlPath = item.url;
  }

  // 检查是否是跳转到需要登录的页面
  // 包括：/activity?tab=vip、/Deposito、/wallet、推广页（/ConvidarCentro）
  const needLogin =
    (urlPath === '/activity?tab=vip' || urlPath.includes('/activity?tab=vip')) ||
    (urlPath === '/Deposito' || urlPath.startsWith('/Deposito')) ||
    (urlPath === '/wallet' || urlPath.startsWith('/wallet')) ||
    (urlPath === '/ConvidarCentro' || urlPath.startsWith('/ConvidarCentro')); // 推广页需要登录

  // 如果需要登录且用户未登录，弹出登录弹窗
  if (needLogin && !isLogin.value) {
    // 获取邀请码
    const inviteCode = (route.query.pid as string) || "";
    // 弹出登录弹窗
    window.$showLoginDialog(inviteCode);
    return; // 不执行跳转，等待登录
  }

  // 执行跳转
  router.push(item.url);
};
/**
 * 跳转到VIP页面
 * @returns void
 */
const toVip = () => {
  router.push("/activity?tab=vip");
};
/**
 * 切换语言
 * @param item 语言项
 * @returns void
 */
const handleLangSelect = (item) => {
  locale.value = item.value;
  showLangSelect.value = false;
};


// 获取神秘矿洞倒计时数据
const getMineCountdown = async () => {
  try {
    const res = await GameApi.CountdownToMine()

    if (res.data && res.data.countDown) {
      mineCountdown.value = res.data.countDown
      startMineCountdown()
    }
  } catch (error) {
    console.error('获取神秘矿洞倒计时失败:', error)
    // 请求失败时停止定时器，避免无限循环
    if (mineCountdownTimer.value) {
      clearInterval(mineCountdownTimer.value)
      mineCountdownTimer.value = null
    }
    // 设置一个默认值，避免显示异常
    mineCountdown.value = 0
  }
}
// 添加定时器管理，防止内存泄漏
const useTimer = () => {
  const timers = ref(new Set())

  const addTimer = (callback, interval) => {
    const timer = setInterval(callback, interval)
    timers.value.add(timer)
    return timer
  }

  const clearAllTimers = () => {
    timers.value.forEach(timer => clearInterval(timer as any))
    timers.value.clear()
  }

  onUnmounted(() => {
    clearAllTimers()
  })

  return { addTimer, clearAllTimers }
}

// 使用定时器管理
const { addTimer, clearAllTimers } = useTimer()
// 开始倒计时
const startMineCountdown = () => {
  // 清除之前的定时器
  if (mineCountdownTimer.value) {
    clearInterval(mineCountdownTimer.value)
  }

  mineCountdownTimer.value = addTimer(() => {
    if (mineCountdown.value > 0) {
      mineCountdown.value--
    } else {
      // 倒计时结束，重新获取数据
      // 添加延迟避免立即重试
      setTimeout(() => {
        getMineCountdown()
      }, 5000) // 5秒后重试
    }
  }, 1000)
}

// 监听 gameList.value.vendorManagerList 的变化，当有数据时调用 getHomeVendorConfig
// watch(() => gameList.value?.vendorManagerList, (newVendorManagerList) => {
//   // 当 vendorManagerList 有数据且 activeVendor 为 0（热门/首页配置）时，调用 getHomeVendorConfig
//   if (newVendorManagerList && newVendorManagerList.length > 0 && activeVendor.value === 0) {
//     // 使用 nextTick 确保数据已完全更新
//     nextTick(() => {
//       getHomeVendorConfig();
//     });
//   }
// }, { deep: true, immediate: false });

// 添加登录状态监听
watch(() => isLogin.value, async (newLoginStatus, oldLoginStatus) => {
  // 如果用户从未登录变为已登录，或者从已登录变为未登录，重新加载数据
  if (newLoginStatus !== oldLoginStatus) {


    // 清除奖励数据
    rewardStore.clearData()

    // 清除API缓存，确保获取最新数据
    apiCache.clear()

    // 清除转盘数据缓存，确保获取最新数据
    turntableDataCache.value = null
    turntableDataCacheTime.value = 0

    // 如果用户退出登录，清理所有用户相关的缓存
    if (!newLoginStatus && oldLoginStatus) {
      console.log('用户退出登录，清理用户相关缓存')
      // 清理所有可能的用户相关缓存
      const keysToRemove = []
      for (let i = 0; i < sessionStorage.length; i++) {
        const key = sessionStorage.key(i)
        if (key && (key.includes('turntable_completed_') || key.includes('skip_turntable_'))) {
          keysToRemove.push(key)
        }
      }
      keysToRemove.forEach(key => {
        sessionStorage.removeItem(key)
        console.log('清理缓存:', key)
      })
    }

    // 重新加载首页基础数据
    try {
      await Promise.allSettled([
        carouselChart(),
        getVendors(),
        getAllList(), // 添加首页配置项加载
        GameApi.batchGetGames().then(res => {
          gameList.value = res.data
          if (gameList.value && res.data.gameMap) {
            gameList.value.originGameMap = JSON.parse(JSON.stringify(res.data.gameMap))
          }
          // 确保 gameMap 存在
          if (gameList.value && !gameList.value.gameMap) {
            gameList.value.gameMap = {}
          }
          // 确保 gameCountMap 存在
          if (gameList.value && !gameList.value.gameCountMap) {
            gameList.value.gameCountMap = {}
          }
          // 确保 vendorManagerList 存在
          if (gameList.value && !gameList.value.vendorManagerList) {
            gameList.value.vendorManagerList = []
          }
          // 当 gameList.value.vendorManagerList 有数据时，调用 getHomeVendorConfig（等同于 index1.vue 中的热门游戏）
          if (gameList.value.vendorManagerList && gameList.value.vendorManagerList.length > 0 && activeVendor.value === 0) {
            nextTick(() => {
              getHomeVendorConfig();
            });
          }
        })
      ])
    } catch (error) {
      console.error('重新加载首页数据失败:', error)
    }

    // 重新获取奖励数据（强制刷新）
    const turntableData = await getNewUserExclusive(true)

    // 如果用户登录了，重新获取用户信息
    if (newLoginStatus) {
      try {
        await userStore.info()
      } catch (error) {
        console.error('重新获取用户信息失败:', error)
      }

      // 登录后检查新用户转盘状态，传递已获取的数据
      await checkNewUserTurntableStatus(turntableData)

      // 检查是否有待跳转的VIP活动页
      const pendingRedirect = sessionStorage.getItem('pending_activity_vip_redirect');
      if (pendingRedirect) {
        // 清除待跳转标记
        sessionStorage.removeItem('pending_activity_vip_redirect');
        // 延迟一下确保登录弹窗已关闭
        setTimeout(() => {
          router.push(pendingRedirect);
        }, 300);
      }

      // 登录后重新检查弹窗优先级并显示弹窗（特别是"每回大厅必弹"的弹窗）
      // 延迟确保登录弹窗已关闭，并且避免和 onMounted 中的检查冲突
      setTimeout(async () => {
        // 重置弹窗关闭状态
        globalPopupClosed.value = false
        newsPopupClosed.value = false
        // 只有在没有正在检查时才检查
        if (!isCheckingPriority.value) {
          // 先确保两个弹窗都隐藏
          showPopup.value = false
          showNewsWindows.value = false
          await checkPopupPriority()
        }
      }, 2000) // 增加延迟，确保所有初始化完成
    }

    // 设置标记，表示登录状态监听器已经处理了数据加载
    sessionStorage.setItem('loginHandlerProcessed', 'true')
  }
})

// 添加路由监听，确保从其他页面回到首页时重新加载数据
watch(() => route.path, async (newPath, oldPath) => {
  console.log('路由变化:', { newPath, oldPath })
  if (newPath === '/' && oldPath && oldPath !== '/') {
    console.log('进入首页，检查是否需要重新加载数据')

    // 从其他页面返回到首页时，重新检查弹窗优先级（特别是"每回大厅必弹"的弹窗）
    setTimeout(async () => {
      // 重置弹窗关闭状态
      globalPopupClosed.value = false
      newsPopupClosed.value = false
      // 只有在没有正在检查时才检查
      if (!isCheckingPriority.value) {
        // 先确保两个弹窗都隐藏
        showPopup.value = false
        showNewsWindows.value = false
        await checkPopupPriority()
      }
    }, 500)

    // 检查登录状态监听器是否已经处理了数据加载
    const loginHandlerProcessed = sessionStorage.getItem('loginHandlerProcessed') === 'true'

    if (loginHandlerProcessed) {
      console.log('登录状态监听器已处理数据加载，跳过路由监听器的数据加载')
      // 清除登录状态监听器标记
      sessionStorage.removeItem('loginHandlerProcessed')
      return
    }

    // 检查是否从抽奖页面返回
    const isFromTurntable = oldPath === '/activity/components/activityIndex/newUsers'
    console.log('是否从抽奖页面返回:', isFromTurntable)

    // 如果不是从抽奖页面返回，清除跳过抽奖页面的标记，允许重新检查
    if (isLogin.value && !isFromTurntable) {
      const userId = userStore.userInfo?.id
      const skipTurntableKey = `skip_turntable_${userId}`
      sessionStorage.removeItem(skipTurntableKey)
      console.log('清除跳过抽奖页面标记:', skipTurntableKey)
    }

    // 检查数据是否为空，如果为空则重新加载
    const needsReload = !carouselChartList.value.length ||
      !vendors.value.length ||
      !Object.keys(gameList.value).length

    if (needsReload) {
      console.log('首页数据为空，重新加载')

      // 清除API缓存
      apiCache.clear()

      // 清除转盘数据缓存
      turntableDataCache.value = null
      turntableDataCacheTime.value = 0

      // 重新加载数据
      try {
        await Promise.allSettled([
          carouselChart(),
          getVendors(),
          getAllList(), // 添加首页配置项加载
          GameApi.batchGetGames().then(res => {
            gameList.value = res.data
            if (gameList.value && res.data.gameMap) {
              gameList.value.originGameMap = JSON.parse(JSON.stringify(res.data.gameMap))
            }
          })
        ])

        // 如果已登录，重新获取用户信息
        if (isLogin.value) {
          await userStore.info()
        }

        // 重新获取奖励数据（强制刷新）
        const turntableData = await getNewUserExclusive(true)

        // 如果不是从抽奖页面返回，才检查新用户转盘状态
        if (!isFromTurntable) {
          await checkNewUserTurntableStatus(turntableData)
        }

      } catch (error) {
        console.error('重新加载首页数据失败:', error)
      }
    } else {
      // 如果不需要重新加载数据，且不是从抽奖页面返回，才检查新用户转盘状态
      if (!isFromTurntable) {
        // 优先使用缓存数据，避免重复调用API
        const cachedData = turntableDataCache.value
        await checkNewUserTurntableStatus(cachedData)
      }
    }

    // 设置标记，表示路由监听器已经处理了数据加载
    sessionStorage.setItem('routeHandlerProcessed', 'true')
  }
}, { immediate: false })


// 优化后的初始化函数 - 并行加载关键数据
const initializePage = async () => {
  const hasLoginStatus = userStore.checkLoginStatus()

  // 设置所有加载状态
  loadingStates.value.carousel = true
  loadingStates.value.vendors = true
  loadingStates.value.games = true
  if (hasLoginStatus && !(userStore as any).userInfoLoaded) {
    loadingStates.value.userInfo = true
  }

  // 并行加载关键数据
  const promises: Promise<any>[] = [
    carouselChart(),
    getVendors(),
    GameApi.batchGetGames()
  ]

  // 如果已登录，添加用户信息请求
  if (hasLoginStatus && !(userStore as any).userInfoLoaded) {
    promises.push(userStore.info() as any)
  }

  try {
    const results = await Promise.allSettled(promises)

    // 处理轮播图结果
    if (results[0].status === 'fulfilled') {
      loadingStates.value.carousel = false
    } else {
      console.error('轮播图加载失败:', results[0].reason)
      loadingStates.value.carousel = false
    }

    // 处理厂商数据结果
    if (results[1].status === 'fulfilled') {
      loadingStates.value.vendors = false
    } else {
      console.error('厂商数据加载失败:', results[1].reason)
      loadingStates.value.vendors = false
    }

    // 处理游戏数据结果
    if (results[2].status === 'fulfilled') {
      gameList.value = results[2].value.data
      // 备份第一页数据
      if (gameList.value && results[2].value.data.gameMap) {
        gameList.value.originGameMap = JSON.parse(JSON.stringify(results[2].value.data.gameMap))
      }
      // 确保 gameMap 存在
      if (!gameList.value.gameMap) {
        gameList.value.gameMap = {}
      }
      // 确保 gameCountMap 存在
      if (!gameList.value.gameCountMap) {
        gameList.value.gameCountMap = {}
      }
      // 确保 vendorManagerList 存在
      if (!gameList.value.vendorManagerList) {
        gameList.value.vendorManagerList = []
      }
      loadingStates.value.games = false
      // 当 gameList.value.vendorManagerList 有数据时，调用 getHomeVendorConfig（等同于 index1.vue 中的热门游戏）
      if (gameList.value.vendorManagerList && gameList.value.vendorManagerList.length > 0 && activeVendor.value === 0) {
        nextTick(() => {
          getHomeVendorConfig();
        });
      }
    } else {
      console.error('游戏数据加载失败:', results[2].reason)
      loadingStates.value.games = false
    }

    // 处理用户信息结果
    if (results[3]) {
      if (results[3].status === 'fulfilled') {
        ; (userStore as any).userInfoLoaded = true
        loadingStates.value.userInfo = false
      } else {
        console.error('用户信息加载失败:', results[3].reason)
        userStore.clearUserInfo()
        loadingStates.value.userInfo = false
      }
    }
  } catch (error) {
    console.error('初始化页面失败:', error)
    // 确保所有加载状态都被重置
    loadingStates.value.carousel = false
    loadingStates.value.vendors = false
    loadingStates.value.games = false
    loadingStates.value.userInfo = false
  }
}

// 使用全局socket实例监听余额变化
const socket = window.$socket

// 监听用户余额变化事件
const handleAmountChange = (info) => {
  // 使用window.console.log避免console.log被重写的问题

  if (info && info.availableAccount !== undefined) {
    // 直接更新用户钱包信息
    userStore.updateUserWallet({
      availableAccount: info.availableAccount
    })
  }
}

// 添加拖拽滚动相关的变量
const isDragging = ref(false)
const startX = ref(0)
const scrollLeft = ref(0)
const isMouseDown = ref(false) // 新增：跟踪鼠标按下状态

// 改进的拖拽滚动相关函数
const handleMouseDown = (e) => {
  if (!vendorScrollRef.value) return

  isMouseDown.value = true
  isDragging.value = true
  startX.value = e.pageX - (vendorScrollRef.value as HTMLElement).offsetLeft
  scrollLeft.value = (vendorScrollRef.value as HTMLElement).scrollLeft

    // 保持手指指针样式
    ; (vendorScrollRef.value as HTMLElement).style.cursor = 'pointer'
    ; (vendorScrollRef.value as HTMLElement).style.userSelect = 'none'

  // 阻止默认行为
  e.preventDefault()
}

const handleMouseMove = (e) => {
  if (!isMouseDown.value || !isDragging.value || !vendorScrollRef.value) return

  e.preventDefault()
  const x = e.pageX - (vendorScrollRef.value as HTMLElement).offsetLeft
  const walk = (x - startX.value) * 1.5 // 降低滚动速度倍数，提高流畅性
    ; (vendorScrollRef.value as HTMLElement).scrollLeft = scrollLeft.value - walk
}

const handleMouseUp = (e) => {
  if (!vendorScrollRef.value) return

  isMouseDown.value = false
  isDragging.value = false
    ; (vendorScrollRef.value as HTMLElement).style.cursor = 'pointer' // 保持手指指针
    ; (vendorScrollRef.value as HTMLElement).style.userSelect = 'auto'

  // 阻止默认行为
  e.preventDefault()
}

const handleMouseLeave = (e) => {
  if (!vendorScrollRef.value) return

  isMouseDown.value = false
  isDragging.value = false
    ; (vendorScrollRef.value as HTMLElement).style.cursor = 'pointer' // 保持手指指针
    ; (vendorScrollRef.value as HTMLElement).style.userSelect = 'auto'
}

// 添加触摸事件支持（移动端）
const handleTouchStart = (e) => {
  if (!vendorScrollRef.value) return

  isDragging.value = true
  startX.value = e.touches[0].pageX - (vendorScrollRef.value as HTMLElement).offsetLeft
  scrollLeft.value = (vendorScrollRef.value as HTMLElement).scrollLeft
}

const handleTouchMove = (e) => {
  if (!isDragging.value || !vendorScrollRef.value) return

  e.preventDefault()
  const x = e.touches[0].pageX - (vendorScrollRef.value as HTMLElement).offsetLeft
  const walk = (x - startX.value) * 1.5
    ; (vendorScrollRef.value as HTMLElement).scrollLeft = scrollLeft.value - walk
}

const handleTouchEnd = (e) => {
  if (!vendorScrollRef.value) return

  isDragging.value = false
}
const loadGameList = async () => {
  const res = await GameApi.batchGetGames()
  gameList.value = res.data
  if (gameList.value && res.data.gameMap) {
    gameList.value.originGameMap = JSON.parse(JSON.stringify(res.data.gameMap))
  }
  // 确保 gameMap 存在
  if (gameList.value && !gameList.value.gameMap) {
    gameList.value.gameMap = {}
  }
  // 确保 gameCountMap 存在
  if (gameList.value && !gameList.value.gameCountMap) {
    gameList.value.gameCountMap = {}
  }
  // 确保 vendorManagerList 存在
  if (gameList.value && !gameList.value.vendorManagerList) {
    gameList.value.vendorManagerList = []
  }
}
const loadPageData = async () => {
  // getActivityList();
  loadVipIcons();
  // getVendors() 和 carouselChart() 已在 initializePage() 中调用，避免重复
  // getVendors();
  // carouselChart();
  // getBannerData() 已在 getAllList() 中调用，避免重复
  // getBannerData();
  getFavoriteGames();
  // 如果 gameList.value.vendorManagerList 已有数据，直接使用；否则等待 initializePage 完成后再调用
  await loadGameList()
  if (activeVendor.value == 0) {
    if (gameList.value.vendorManagerList && gameList.value.vendorManagerList.length > 0 && activeVendor.value === 0) {
      nextTick(() => {
        getHomeVendorConfig();
      });
    }
  } else {
    handleVendorClick(homeVendorGameConfig.value[activeVendor.value - 1], activeVendor.value - 1)
  }

  // if (gameList.value && gameList.value.vendorManagerList && gameList.value.vendorManagerList.length > 0) {
  //   getHomeVendorConfig();
  // }
  // 否则会在 initializePage 完成后通过 watch 触发
}

// 优化后的 onMounted - 并行执行初始化任务
onMounted(async () => {
  // 检查登录和注册参数
  const loginParam = route.query.login
  const regParam = route.query.reg

  if (loginParam) {
    const inviteCode = route.query.pid as string || sessionStorage.getItem('inviteCode') || ''
    window.$showLoginDialog(inviteCode)
  } else if (regParam) {
    // 如果有 reg 参数，打开注册弹窗
    const inviteCode = route.query.pid as string || sessionStorage.getItem('inviteCode') || ''
    window.$showRegisterDialog(inviteCode)
  } else {
    // 检查自动注册（保持原有逻辑）
    const autoRegister = route.query.autoRegister
    if (autoRegister) {
      window.$showRegisterDialog()
    }
  }

  // 检查是否正在退出登录
  const isLoggingOut = sessionStorage.getItem('is_logging_out') === 'true'
  if (isLoggingOut) {
    console.log('正在退出登录，跳过首页初始化')
    sessionStorage.removeItem('is_logging_out')
    await getMineCountdown()
    return
  }

  // 并行执行初始化任务
  const initTasks = [
    getAllList(),
    loadPageData(),
    checkPidParameter(),
    initializePage()
  ]

  // 如果已登录，添加用户信息更新
  if (isLogin.value) {
    initTasks.push(
      (userStore.info() as any).catch((error: any) => {
        console.error('调用 center/email/info 失败:', error)
      })
    )
  }

  // 并行执行所有初始化任务
  await Promise.allSettled(initTasks)

  // 检查路由监听器是否已经处理了数据加载
  const routeHandlerProcessed = sessionStorage.getItem('routeHandlerProcessed') === 'true'

  if (!routeHandlerProcessed) {
    // 如果路由监听器没有处理，则在这里处理
    console.log('路由监听器未处理，在onMounted中处理数据加载')

    // 并行获取倒计时和奖励数据
    const [mineResult, turntableData] = await Promise.allSettled([
      getMineCountdown(),
      getNewUserExclusive()
    ])

    // 检查新用户转盘抽奖状态，使用已获取的数据
    await checkNewUserTurntableStatus(turntableData.status === 'fulfilled' ? turntableData.value : null)
  } else {
    // 如果路由监听器已经处理了，只获取倒计时数据
    console.log('路由监听器已处理数据加载，只获取倒计时数据')
    await getMineCountdown()

    // 清除标记
    sessionStorage.removeItem('routeHandlerProcessed')
  }

  // 使用 nextTick 确保用户信息已完全加载后再检查弹窗
  await nextTick()
  await checkFirstRechargeRebate()

  // 先获取弹窗优先级，然后按优先级显示弹窗
  await checkPopupPriority()

  // 重置弹窗关闭状态，确保每次进入首页都能重新检查
  globalPopupClosed.value = false
  newsPopupClosed.value = false

  // 添加事件监听
  homePageRef.value?.addEventListener('scroll', handleScroll, { passive: true })

  // 添加拖拽滚动事件监听
  if (vendorScrollRef.value) {
    ; (vendorScrollRef.value as HTMLElement).addEventListener('mousedown', handleMouseDown)
      ; (vendorScrollRef.value as HTMLElement).addEventListener('mousemove', handleMouseMove)
      ; (vendorScrollRef.value as HTMLElement).addEventListener('mouseup', handleMouseUp)
      ; (vendorScrollRef.value as HTMLElement).addEventListener('mouseleave', handleMouseLeave)
      ; (vendorScrollRef.value as HTMLElement).addEventListener('touchstart', handleTouchStart, { passive: false })
      ; (vendorScrollRef.value as HTMLElement).addEventListener('touchmove', handleTouchMove, { passive: false })
      ; (vendorScrollRef.value as HTMLElement).addEventListener('touchend', handleTouchEnd, { passive: false })
  }

  // Socket监听
  if (socket && socket.isConnected()) {
    socket.on('user_amount_change_notice', handleAmountChange)
  }
  if (socket) {
    socket.on('amountChange', handleAmountChange)
  }

  // 加载奖励数据
  rewardStore.loadFromStorage()

  // 开始倒计时
  if (rewardStore.countdownSeconds > 0 && rewardStore.status === 0) {
    startHomeCountdown()
  }
})

// 修改 onUnmounted
onUnmounted(() => {
  homePageRef.value?.removeEventListener('scroll', handleScroll)

  // 移除拖拽滚动事件监听
  if (vendorScrollRef.value) {
    // 鼠标事件
    ; (vendorScrollRef.value as HTMLElement).removeEventListener('mousedown', handleMouseDown)
      ; (vendorScrollRef.value as HTMLElement).removeEventListener('mousemove', handleMouseMove)
      ; (vendorScrollRef.value as HTMLElement).removeEventListener('mouseup', handleMouseUp)
      ; (vendorScrollRef.value as HTMLElement).removeEventListener('mouseleave', handleMouseLeave)

      // 触摸事件
      ; (vendorScrollRef.value as HTMLElement).removeEventListener('touchstart', handleTouchStart)
      ; (vendorScrollRef.value as HTMLElement).removeEventListener('touchmove', handleTouchMove)
      ; (vendorScrollRef.value as HTMLElement).removeEventListener('touchend', handleTouchEnd)
  }

  // 清理socket事件监听
  if (socket) {
    socket.off('user_amount_change_notice', handleAmountChange)
  }
  // 清理定时器
  if (mineCountdownTimer.value) {
    clearInterval(mineCountdownTimer.value)
    mineCountdownTimer.value = null
  }
  // 移除socket监听
  if (socket) {
    socket.off('amountChange', handleAmountChange)
  }

  // 清理首页倒计时定时器
  stopHomeCountdown()
})
</script>

<style lang="scss">
.double-wallet {
  background-image: getPath("home/doubleWalletBg.png");
  background-size: 100% calc(100% + 6px);
  background-position: 0 -3px;
  background-repeat: no-repeat;
}

.arrow {
  display: inline-block;
  background-image: getPath("home/double-wallet-arrow.png");
  width: 8px;
  height: 7px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  /* 添加!important确保优先级 */
  transition: transform 0.2s;
}

.fixed-top-btn {
  position: fixed;
  bottom: 100px;
  right: 20px;
  width: 40px;
  height: 40px;
  cursor: pointer;
  z-index: 99;
  transition: all 0.3s;
}


.selectLangContainer {

  background: getPath("home/selectLangBg.png") no-repeat;
  background-size: 100% 100%;

}

:deep(.van-popover .van-popover__arrow) {
  display: none;
}

@keyframes bounce-twice {
  0% {
    transform: translateY(0);
  }

  7% {
    transform: translateY(0);
  }

  10% {
    transform: translateY(-10px);

  }

  14% {
    transform: translateY(-4px);

  }

  18% {
    transform: translateY(-8px);

  }

  21% {
    transform: translateY(0);
  }

  100% {
    transform: translateY(0);
    /* 保持原位 */
  }
}

/* 公告栏红点样式 */
.ticker-badge-dot {
  position: absolute;
  top: 0px;
  right: -2px;
  min-width: 17px;
  height: 17px;
  background: #FF3B30;
  // border-radius: 50%;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  // color: #fff;
  font-size: 9px;
  font-weight: bold;
  text-align: center;
  line-height: 1;
  padding: 0 2px;
}

@keyframes float-up-down {
  50% {
    transform: translateY(-5px);
  }
}

.floating-element {
  animation: float-up-down 3s ease-in-out infinite;
}

.bouncing-element {
  animation: bounce-twice 5s cubic-bezier(0.42, 0, 0.58, 1) infinite;
  /* 可选性能优化 */
  transform: translateZ(0);
  will-change: transform;
}

@keyframes iconBounce {

  0% {}

  100% {
    transform: scale(1) rotate(0);
  }

  25% {
    transform: scale(1.1) rotate(-5deg);
  }

  50% {
    transform: scale(1.05) rotate(0);
  }

  75% {
    transform: scale(1.1) rotate(5deg);
  }
}

.support-icons {
  animation: iconBounce 2s ease-in-out infinite;
}

/* 小幅度弹跳动画 */
@keyframes bounceSmall {

  0%,
  100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-3px);
  }
}

.bounce-small {
  animation: bounceSmall 600ms ease-in-out infinite;
}

/* 红色圆点提示 */
.red-dot {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 10px;
  height: 10px;
  background-color: red;
  border-radius: 50%;
  z-index: 20;
  /* 提高 z-index */
  /* animation: pulse 2s infinite; */
}

.quickActivityContent {
  background: getPath("home/quickActivityContentBg.png") no-repeat;
  background-size: 100% calc(100% + 4px);

  .itemBox {
    width: 50px;
    height: 50px;
    background: getPath("home/itemBox.png") no-repeat;
    background-size: 100% 100%;
  }
}

.home-container {
  background: getPath("home/homeBg.png") no-repeat center center;
  background-size: 100% 100%;
  overflow-y: auto;

  * {
    -webkit-transition-property: all;
    -o-transition-property: all;
    transition-property: all;
    -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    -o-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    -webkit-transition-duration: 150ms;
    -o-transition-duration: 150ms;
    transition-duration: 150ms;
  }

  // 头部区域
  .header-area {
    height: 63px;
    background: getPath("home/headbg.png") no-repeat center center;
    background-size: 100% 100%;

    .wallet {
      background-image: getPath("home/walletButtonBg.png");
      background-size: 100% calc(100% + 4px);
      background-repeat: no-repeat;
      box-shadow: 0px 0px 4px 4px rgba(0, 0, 0, 0.35);
      border-radius: 100px;
    }

    .login {
      background-image: getPath("home/loginButtonBg.png");
      background-size: calc(100% + 4px) calc(100% + 6px);
      background-position: -2px -2px;
      background-repeat: no-repeat;
      box-shadow: 0px 0px 2px 2px rgba(0, 0, 0, 0.35);
      border-radius: 100px;
    }

    .register {
      background-image: getPath("home/registerButtonBg.png");
      background-size: calc(100% + 4px) calc(100% + 6px);
      background-position: -2px -2px;
      background-repeat: no-repeat;
      box-shadow: 0px 0px 2px 2px rgba(0, 0, 0, 0.35);
      border-radius: 100px;
    }
  }

  // 内容区域
  .content-area {
    overflow-y: auto;
    padding: 15px;

    // 轮播图容器
    .carousel-container {
      width: 100%;
      height: 120px;
      background: getPath("home/carouselContainerBorderBg.png") no-repeat;
      background-size: 100% 100%;
      border-radius: 8.5px;
      overflow: hidden;

      /* 添加加载状态样式 */
      .swipe-loading,
      .vendor-loading,
      .hot-games-loading,
      .games-loading {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 100px;
        background: rgba(0, 0, 0, 0.05);
        border-radius: 8.5px;
      }

      .swipe-loading {
        height: 221px;
      }

      .van-popover[data-popper-placement^="bottom"] .van-popover__arrow {
        border-bottom-color: #15b693;
      }
    }

    // 跑马灯容器
    .ticker-container {
      height: 36px;
      background: getPath("home/tickerBg.png") no-repeat;
      background-size: 100% 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;


      // 使用伪元素让背景图产生流动闪烁效果
      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: getPath("home/tickerBg.png") no-repeat;
        background-size: 100% 100%;
        // 使用滤镜让发光点产生流动效果
        filter: brightness(1);
        animation: borderFlow 2s linear infinite;
        z-index: 0;
      }

      // 确保内容在背景之上
      >* {
        position: relative;
        z-index: 1;
      }
    }

    // 边框流动闪烁动画 - 通过滤镜实现
    @keyframes borderFlow {

      0%,
      100% {
        filter: brightness(1) contrast(1);
      }

      25% {
        filter: brightness(1.3) contrast(1.2);
      }

      50% {
        filter: brightness(1.5) contrast(1.4);
      }

      75% {
        filter: brightness(1.3) contrast(1.2);
      }
    }

    // 广告位容器
    .banner-container {

      // 广告位项
      .banner-item {
        background: getPath("home/bannerItemBorderBg.png") no-repeat;
        background-size: calc(100% + 5px) calc(100% + 0px);
        background-position: -1px 0;
      }
    }

    // 厂商列表容器
    .vendor-container {
      height: 33px;
      padding: 1px;
      background: getPath("home/vendorListBg.png") no-repeat center center;
      background-size: calc(100% + 1px) calc(100% + 2px);
      background-position: 0px 0px;
      border-radius: 100vh;
      padding: 0 1px;

      // 点赞按钮
      .active {
        background: getPath("home/vendorLikeButtonBg.png") no-repeat;
        background-size: calc(100% + 1px) calc(100% + 4px);
        background-position: 0 -3px;
      }

      .like {
        background: getPath("home/vendorLikeButtonBg.png") no-repeat;
        background-size: calc(100% + 1px) calc(100% + 4px);
        background-position: 0 -3px;
      }
    }

    // 搜索容器
    .search-container {

      // 搜索框
      .search {
        background: getPath("home/searchBg.png") no-repeat center center;
        background-size: calc(100% + 3px) calc(100% + 4px);
        background-position: -2px -2px;
      }
    }

    // 收藏游戏容器
    .favorite-games-container {

      // 收藏游戏标题
      .title {
        background: getPath("home/favoriteGamesTitleBg.png") no-repeat center center;
        background-size: 100% 100%;
      }
    }

    // 游戏列表容器
    .game-list-container {


      .svgstag {
        width: 100%;
        height: 44px;
        /* 根据需要调整高度 */
        background-image: getPath("home/headerTextBgGreen02.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        position: relative;
        display: flex;
        align-items: center;
      }
    }
  }

  // 底部区域
  .bottom-area {

    /* 全局放大然后左上角往下敲动，右上角往左敲动的动画 */
    @keyframes dogActivityAnimation {
      0% {
        transform: scale(1) rotate(0deg) skew(0deg, 0deg);
      }

      20% {
        transform: scale(1.15) rotate(0deg) skew(0deg, 0deg);
      }

      40% {
        transform: scale(1.15) rotate(-10deg) skew(-5deg, 0deg);
      }

      50% {
        transform: scale(1.15) rotate(10deg) skew(5deg, 0deg);
      }

      60% {
        transform: scale(1.15) rotate(-7deg) skew(-3deg, 0deg);
      }

      70% {
        transform: scale(1.15) rotate(7deg) skew(3deg, 0deg);
      }

      80% {
        transform: scale(1.15) rotate(-3deg) skew(-1deg, 0deg);
      }

      90% {
        transform: scale(1.1) rotate(0deg) skew(0deg, 0deg);
      }

      100% {
        transform: scale(1) rotate(0deg) skew(0deg, 0deg);
      }
    }

    .fixed-top-btnKefus {
      background: transparent;
      position: fixed;
      bottom: 148px !important;
      left: 20px;
      width: 50px;
      height: 50px;
      cursor: pointer;
      z-index: 99;
      /* 添加安全区域适配 */
      bottom: calc(58px + env(safe-area-inset-bottom));

      .kefus-badge-dot {
        position: absolute;
        top: 6px;
        right: 6px;
        width: 8px;
        height: 8px;
        background: #ff3b30;
        border-radius: 50%;
        z-index: 10;
      }
    }

    .fixed-top-btn {
      position: fixed;
      bottom: 60px;
      right: 20px;
      width: 40px;
      height: 40px;
      cursor: pointer;
      z-index: 99;
      transition: all 0.3s;
    }

    .fuchaungs {
      position: fixed;
      bottom: 20%;
      right: 10px;
      z-index: 999 !important;

      .fuchangscenter {
        width: 115px;
        height: 85px;
        background: getPath("activity/ews.png") no-repeat center center;
        background-size: 100% 100%;
        cursor: pointer;
        padding: 15px 10px;
      }

      .dogactivity {
        background: getPath("activity/redpackes.png") no-repeat center center;
        background-size: 100% 100%;
        width: 105px;
        height: 76px;
        z-index: 99;
        cursor: pointer;
        transform-origin: center center;
        animation: dogActivityAnimation 1.2s ease-in-out infinite;
        transition: all 0.3s ease;
        display: flex;
        align-items: center;
        justify-content: center;

        .countdown-overlay {
          position: absolute;
          top: 40%;
          left: 50%;
          transform: translate(-50%, -50%);
          text-align: center;
          z-index: 10;

          .countdown-text {
            color: #fff268;
            font-size: 12px;
            font-weight: bold;
            padding: 4px 8px;
            border-radius: 4px;
            white-space: nowrap;
          }
        }
      }

      .dogactivity:hover {
        transform: scale(2);
      }
    }

    .footerstyle {
      background: rgba(0, 104, 73, 0.52);
      margin: 10px 13px;
      padding: 20px 16px 16px 16px;
      border-radius: 9px;
      color: #53b68b;
      font-size: 14px;
    }

    /* PC端字体大小调整 */
    @media (min-width: 768px) {
      .footerstyle {
        font-size: 10px;
        /* PC端字体大小 */
      }
    }

    /* 大屏幕字体大小调整 */
    @media (min-width: 1024px) {
      .footerstyle {
        font-size: 10px;
        /* 大屏幕字体大小 */
      }
    }

    /* 超大屏幕字体大小调整 */
    @media (min-width: 1440px) {
      .footerstyle {
        font-size: 10px;
        /* 超大屏幕字体大小 */
      }
    }
  }
}

.pop-container {
  * {
    -webkit-transition-property: all;
    -o-transition-property: all;
    transition-property: all;
    -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    -o-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    -webkit-transition-duration: 150ms;
    -o-transition-duration: 150ms;
    transition-duration: 150ms;
  }

  .popHeader {
    background: linear-gradient(0deg, #167e56, #004f4e);
    box-shadow: 0px 5px 6px 0px rgba(0, 0, 0, 0.5),
      0px -5px 43px 0px rgba(53, 189, 128, 0.61);
  }

  .popContent {
    background: getPath("home/homeBg.png") no-repeat center center;
    background-size: 100% 100%;

    .gameTypes {
      .gameTypesItem {
        background: getPath("home/popGameTypesBg.png") no-repeat center center;
        background-size: 100% 100%;

        .gameTypesItemIcon {
          background: getPath("home/popGameTypeIconBg.png") no-repeat center center;
          background-size: calc(100% + 4px) calc(100% + 4px);
        }
      }
    }

    .betRecordContainer {
      background: getPath("home/popBetRecordBg.png") no-repeat center center;
      background-size: 100% 100%;

      .betRecordLeft {
        background: getPath("home/popBetRecordLeftBg.png") no-repeat center center;
        background-size: 100% 100%;
      }
    }

    .customerServiceContainer {
      background: getPath("home/customerServiceContainerBorderBg.png") no-repeat center center;
      background-size: 100% 100%;

      .box {
        background: getPath("home/customerServiceContainerBoxBg.png") no-repeat center center;
      }
    }

    .bannerContainer {
      .box {
        background: getPath("home/popBannerItemBorderBg.png") no-repeat center center;
        background-size: 100% 100%;
      }
    }
  }
}

:root {
  --van-popover-dark-background: transparent !important;
}
</style>

<route lang="json5">
{
  name: "home",
  meta: {
    title: "主页",
    i18n: "menus.home",
  },
}
</route>
